webpackJsonp([1],{

/***/ 157:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_People__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_News__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Agency__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Contact__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Imprint__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Footer__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Parallax__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_DataProtection_vue__ = __webpack_require__(599);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            matchedSize: '',
            scrollOffset: -60
        };
    },

    components: {
        sectionPeople: __WEBPACK_IMPORTED_MODULE_0__components_People__["a" /* default */],
        sectionNews: __WEBPACK_IMPORTED_MODULE_1__components_News__["a" /* default */],
        sectionAgency: __WEBPACK_IMPORTED_MODULE_2__components_Agency__["a" /* default */],
        sectionContact: __WEBPACK_IMPORTED_MODULE_3__components_Contact__["a" /* default */],
        modalImprint: __WEBPACK_IMPORTED_MODULE_4__components_Imprint__["a" /* default */],
        sectionFooter: __WEBPACK_IMPORTED_MODULE_5__components_Footer__["a" /* default */],
        sectionParallax: __WEBPACK_IMPORTED_MODULE_6__components_Parallax__["a" /* default */],
        modalDataProtection: __WEBPACK_IMPORTED_MODULE_7__components_DataProtection_vue__["a" /* default */]
    },

    computed: {
        isLanguageNotFrench: function isLanguageNotFrench() {
            return this.language !== 'fr';
        },
        isLanguageNotGerman: function isLanguageNotGerman() {
            return this.language !== 'de';
        }
    },
    methods: {
        matchMedia: function matchMedia(alias, matches) {
            if (alias === 'xs' && matches) {
                //console.log("xs");
                this.matchedSize = 'xs';
                this.scrollOffset = -200;
            } else if (alias === 'sm' && matches) {
                //console.log("sm");
                this.matchedSize = 'sm';
                this.scrollOffset = -200;
            } else if (alias === 'md' && matches) {
                //console.log("md");
                this.matchedSize = 'md';
                this.scrollOffset = -100;
            } else if (alias === 'lg' && matches) {
                //console.log("lg");
                this.matchedSize = 'lg';
                this.scrollOffset = -100;
            } else if (alias === 'xl' && matches) {
                //console.log("xl");
                this.matchedSize = 'xl';
                this.scrollOffset = -100;
            }
        },
        getOffset: function getOffset() {
            console.log("offset is: " + this.scrollOffset);
            return this.scrollOffset;
        }
    }
});

/***/ }),

/***/ 158:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_People_vue__ = __webpack_require__(159);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a493eb3_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_People_vue__ = __webpack_require__(553);
function injectStyle (ssrContext) {
  __webpack_require__(532)
}
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_People_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a493eb3_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_People_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 159:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PeopleRow__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(57);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        sectionPeopleRow: __WEBPACK_IMPORTED_MODULE_1__PeopleRow__["a" /* default */]
    },
    data: function data() {
        return {
            matchedSize: '',
            all: true,
            ladies: true,
            gents: true,
            a_z: true,
            acting: true,
            presenting: false,
            actor_male: true,
            actor_female: true,
            moderator_male: true,
            moderator_female: true,
            selectedLine: '',
            selectedActorId: -1,
            numberOfActorsPerLine: 3,
            hash: location.hash,
            deeplinkActor: null,
            allActors: [
                /*                    {
                                        'pv_id': 53,
                                        'pv_vorname' : 'Jesse',
                                        'pv_nachname' : 'Albert',
                                        'pv_geschlecht' : 'm',
                                        'pv_bild': 'http://heimanns-agentur.de/medien/bilder/53_ov_1408633333.png'
                                    },
                                    {
                                        'pv_id': 67,
                                        'pv_vorname' : 'Nagmeh',
                                        'pv_nachname' : 'Alaei',
                                        'pv_geschlecht' : 'w',
                                        'pv_bild': 'http://heimanns-agentur.de/medien/bilder/67_ov_1492093007.png'
                                    },
                                    {
                                        'pv_id': 5,
                                        'pv_vorname' : 'Jochen',
                                        'pv_nachname' : 'Alexander Wigand',
                                        'pv_geschlecht' : 'm',
                                        'pv_bild': 'http://heimanns-agentur.de/medien/bilder/5_ov_1508159939.png'
                                    },
                                    {
                                        'pv_id': 56,
                                        'pv_vorname' : 'Julia',
                                        'pv_nachname' : 'Schmitt',
                                        'pv_geschlecht' : 'w',
                                        'pv_bild': 'http://heimanns-agentur.de/medien/bilder/56_ov_1480512250.png'
                                    },
                                    {
                                        'pv_id': 16,
                                        'pv_vorname' : 'Sema',
                                        'pv_nachname' : 'Wittgenstein (vormals Meray)',
                                        'pv_geschlecht' : 'w',
                                        'pv_bild': 'http://heimanns-agentur.de/medien/bilder/16_ov_1513001090.png'
                                    }
                */
            ],
            dummyActor: {
                'pv_id': -1,
                'pv_vorname': '',
                'pv_nachname': '',
                'pv_geschlecht': '',
                'pv_bild': ''
            },
            /*                actorsPerLines : [
                                {
                                    line : 'line1',
                                    actors : [ 
                                        {
                                            'pv_id': 53,
                                            'name': 'Jesse Albert',
                                            'image': 'http://heimanns-agentur.de/medien/bilder/53_ov_1408633333.png'
                                        },
                                        {
                                            'pv_id': 67,
                                            'name': 'Nagmeh Alaei',
                                            'image': 'http://heimanns-agentur.de/medien/bilder/67_ov_1492093007.png'
                                        },
                                        {
                                            'pv_id': 5,
                                            'name': 'Jochen Alexander Wigand',
                                            'image': 'http://heimanns-agentur.de/medien/bilder/5_ov_1508159939.png'
                                        }
                                    ]
                                }, 
                                {
                                    line : 'line2',                           
                                    actors : [ 
                                        {
                                            'pv_id': 56,
                                            'name': 'Julia Schmitt',
                                            'image': 'http://heimanns-agentur.de/medien/bilder/56_ov_1480512250.png'
                                        },
                                        {
                                            'pv_id': 16,
                                            'name': 'Sema Wittgenstein (vormals Meray)',
                                            'image': 'http://heimanns-agentur.de/medien/bilder/16_ov_1513001090.png'
                                        },
                                        {
                                            'pv_id': -1,
                                            'name': '',
                                            'image': 'http://heimanns-agentur.de/medien/bilder/16_ov_1513001090.png'
                                        },
                                    ]
                                }
                            ] */
            actorsPerLines: [],
            scrollTop: 0
        };
    },

    methods: {
        matchMedia: function matchMedia(alias, matches) {
            if (alias === 'xs' && matches) {
                console.log("xs");
                this.matchedSize = 'xs';
            } else if (alias === 'sm' && matches) {
                console.log("sm");
                this.matchedSize = 'sm';
            } else if (alias === 'md' && matches) {
                console.log("md");
                this.matchedSize = 'md';
            } else if (alias === 'lg' && matches) {
                console.log("lg");
                this.matchedSize = 'lg';
            } else if (alias === 'xl' && matches) {
                console.log("xl");
                this.matchedSize = 'xl';
            }
            this.startUpdate();
        },
        startUpdate: function startUpdate() {
            if (this.matchedSize === 'xs') {
                this.updateActorsPerLines(1, true);
            } else if (this.matchedSize === 'sm') {
                this.updateActorsPerLines(2, true);
            } else if (this.matchedSize === 'md') {
                this.updateActorsPerLines(3, true);
            } else if (this.matchedSize === 'lg') {
                this.updateActorsPerLines(4, true);
            } else if (this.matchedSize === 'xl') {
                this.updateActorsPerLines(5, true);
            }
        },
        hideAllCollapsedContent: function hideAllCollapsedContent(selectedActorLine) {
            //alert("selectedActorLine " + JSON.stringify(selectedActorLine));
            this.actorsPerLines.forEach(function (actorsPerLine) {
                if (selectedActorLine.line !== actorsPerLine.line) {
                    $('#' + actorsPerLine.line).collapse('hide');
                }
            });
        },
        isSameLineFn: function isSameLineFn(line) {
            //console.log ("Selected line is: " + this.selectedLine);
            //alert("Line:" + line + "/actorId:" + actorId + 
            //" -- selectedLine:" + this.selectedLine + "/selectedActorId:" + this.selectedActorId);
            return line === this.selectedLine;
        },
        isSameActorFn: function isSameActorFn(actorId) {
            //console.log ("Selected actorId is: " + this.selectedActorId);
            //alert("Line:" + line + "/actorId:" + actorId + 
            //" -- selectedLine:" + this.selectedLine + "/selectedActorId:" + this.selectedActorId);
            return actorId === this.selectedActorId;
        },
        sortActorsAlphabetically: function sortActorsAlphabetically() {
            //https://stackoverflow.com/questions/6712034/sort-array-by-firstname-alphabetically-in-javascript
            var normalize = function normalize(str) {
                return str.toLowerCase().replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss');
            };

            this.allActors.sort(function (a, b) {
                var name1 = normalize(a.pv_nachname + '_' + a.pv_vorname);
                var name2 = normalize(b.pv_nachname + '_' + b.pv_vorname);
                return name1.localeCompare(name2);
            });
        },
        shuffleAllActors: function shuffleAllActors() {
            //https://stackoverflow.com/questions/2450954/how-to-randomize-shuffle-a-javascript-array
            var currentIndex = this.allActors.length,
                temporaryValue,
                randomIndex;
            // While there remain elements to shuffle...
            while (0 !== currentIndex) {
                // Pick a remaining element...
                randomIndex = Math.floor(Math.random() * currentIndex);
                currentIndex -= 1;
                // And swap it with the current element.
                temporaryValue = this.allActors[currentIndex];
                this.allActors[currentIndex] = this.allActors[randomIndex];
                this.allActors[randomIndex] = temporaryValue;
            }
        },
        filterMedia: function filterMedia(changedCheckbox) {
            var _this = this;

            // Prevent that all checkboxes are unchecked
            var randomizeAllActorsList = false;
            /*    if(changedCheckbox === 'a_f') {
                    if(!this.actor_female && !this.actor_male && !this.moderator_female && !this.moderator_male) {
                        this.actor_female = true;
                        return;
                    }
                }
                if(changedCheckbox === 'a_m') {
                    if(!this.actor_female && !this.actor_male && !this.moderator_female && !this.moderator_male) {
                        this.actor_male = true;
                        return;
                    }
                }
                if(changedCheckbox === 'm_f') {
                    if(!this.actor_female && !this.actor_male && !this.moderator_female && !this.moderator_male) {
                        this.moderator_female = true;
                        return;
                    }
                }
                if(changedCheckbox === 'm_m') {
                    if(!this.actor_female && !this.actor_male && !this.moderator_female && !this.moderator_male) {
                        this.moderator_male = true;
                        return;
                    }
                }*/
            if (changedCheckbox === 'a_f') {
                if (!this.actor_female && !this.actor_male) {
                    this.actor_female = true;
                    return;
                }
            }
            if (changedCheckbox === 'a_m') {
                if (!this.actor_female && !this.actor_male) {
                    this.actor_male = true;
                    return;
                }
            }
            /*
            if(changedCheckbox === 'all') {
                if(this.all) {
                    this.ladies = false;
                    this.gents = false;
                }
            }
            if(changedCheckbox === 'ladies') {
                if(this.ladies) {
                    this.all = false;
                    this.gents = false;
                } else if(!this.gents) {
                    this.ladies = true;
                } 
            }
            if(changedCheckbox === 'gents') {
                if(this.gents) {
                    this.ladies = false;
                    this.all = false;
                } else if(!this.ladies) {
                    this.gents = true;
                } 
            }
            */
            if (changedCheckbox === 'acting') {
                if (this.acting) {
                    this.presenting = false;
                }
            }
            if (changedCheckbox === 'presenting') {
                if (this.presenting) {
                    this.acting = false;
                }
            }
            if (changedCheckbox === 'a_z') {
                randomizeAllActorsList = true;
            }

            // Reset
            this.actorsPerLines.forEach(function (actorsPerLine) {
                if (_this.selectedLine === actorsPerLine.line) {
                    $('#' + actorsPerLine.line).collapse('hide');
                }
            });
            this.selectedLine = '';
            this.selectedActorId = -1;
            this.updateActorsPerLines(this.numberOfActorsPerLine, randomizeAllActorsList);
        },
        updateActorsPerLines: function updateActorsPerLines(numberOfActorsPerLine, randomizeAllActorsList) {
            var _this2 = this;

            // For Deep-Linking merke actor und actorsPerLine
            var pv_id = "";
            if (this.hash.indexOf("#people?pv_id=") !== -1) {
                pv_id = this.hash.substring(14);
            }
            console.log(pv_id);

            if (this.a_z) {
                this.sortActorsAlphabetically();
            } else {
                if (randomizeAllActorsList) {
                    this.shuffleAllActors();
                }
            }
            this.numberOfActorsPerLine = numberOfActorsPerLine;
            this.actorsPerLines = [];

            var lineIndex = 0;
            var actorIndex = 0;
            var actors = [];
            this.allActors.forEach(function (actor) {
                //Filter male/female actors
                //alert("actor: " + JSON.stringify(actor) + "\nmale: " + this.actor_male+ "\nfemale: " + this.actor_female);

                if (actor.pv_geschlecht === 'm' && actor.pv_actor && _this2.actor_male || actor.pv_geschlecht === 'w' && actor.pv_actor && _this2.actor_female
                /* || (actor.pv_geschlecht === 'm' && actor.pv_moderator && this.moderator_male)
                 || (actor.pv_geschlecht === 'w' && actor.pv_moderator && this.moderator_female)*/
                ) {
                        //console.log("Add " + JSON.stringify(actor));
                        actors.push(actor);
                    }

                //console.log(this.all + " " + this.ladies + " " + this.gents);
                /*if ((this.acting && actor.pv_actor && this.all)
                 || (this.acting && actor.pv_actor && actor.pv_geschlecht === 'w' && this.ladies)
                 || (this.acting && actor.pv_actor && actor.pv_geschlecht === 'm' && this.gents)
                 || (this.presenting && actor.pv_moderator && this.all)
                 || (this.presenting && actor.pv_moderator && actor.pv_geschlecht === 'w' && this.ladies)
                 || (this.presenting && actor.pv_moderator && actor.pv_geschlecht === 'm' && this.gents)) {
                     //console.log("Add " + JSON.stringify(actor));
                     actors.push(actor);                         
                }*/

                // Deep link
                if (pv_id === actor.pv_id) {
                    console.log("setdeeplinkActor " + actor);
                    _this2.deeplinkActor = actor;
                }

                actorIndex++;
                if (actors.length === numberOfActorsPerLine) {
                    _this2.actorsPerLines.push({
                        line: 'line' + lineIndex,
                        lineIndex: lineIndex,
                        actors: actors
                    });
                    lineIndex++;
                    actorIndex = 0;
                    actors = [];
                }
            });
            while (actors.length < numberOfActorsPerLine) {
                var id = -1 * (numberOfActorsPerLine - actors.length);
                this.dummyActor.pv_id = id;
                actors.push({
                    pv_id: id,
                    pv_vorname: this.dummyActor.pv_vorname,
                    pv_nachname: this.dummyActor.pv_nachname,
                    pv_geschlecht: this.dummyActor.pv_geschlecht,
                    pv_bild: this.dummyActor.pv_bild
                });
            }
            this.actorsPerLines.push({
                line: 'line' + lineIndex,
                lineIndex: lineIndex,
                actors: actors
            });
        }
    },
    created: function created() {
        var _this3 = this;

        //window.addEventListener('scroll', this.storeScrollValues);
        __WEBPACK_IMPORTED_MODULE_0__main__["eventBus"].$on('selectActor', function (data) {
            if (_this3.selectedActorId === data.actor.pv_id) {
                //alert('Same Actor ' + JSON.stringify(data));
                _this3.selectedLine = '';
                _this3.selectedActorId = -1; // Reset
            } else {
                //alert('New Actor ' + JSON.stringify(data));
                _this3.selectedLine = data.line;
                _this3.selectedActorId = data.actor.pv_id;
            }
            _this3.hideAllCollapsedContent(data);

            //window.addEventListener('resize', function(e) {
            //    console.log("RESIZE");
            //});
            //window.resizeTo(500,500);
        });

        //this.$http.get(url.scheme + '://service.heimanns-agentur.de/api/people')
        this.$http.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].scheme + '://relaunch2018.heimanns-agentur.de/api/people').then(function (response) {
            return response.json();
        }).then(function (data) {
            _this3.allActors = data.results;
            console.log("All Actors fetched from DB");
            _this3.startUpdate();

            //Beispiel: http://localhost:8080/#people?pv_id=58
            //console.log("Hash=" + this.hash);                    

            if (_this3.hash.indexOf("#people?pv_id=") !== -1) {
                var pv_id = _this3.hash.substring(14);
                //console.log ("Deep-Link for pv_id = " + pv_id);
                if (pv_id > -1) {
                    setTimeout(function () {
                        $('#' + _this3.deeplinkActor.pv_id).trigger("toggle.collapse");
                        $('#thumb_' + _this3.deeplinkActor.pv_id).trigger("click");
                    }, 200);
                }
            }
        });
    }
});

/***/ }),

/***/ 160:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PeopleRowThumb__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PeopleRowActor__ = __webpack_require__(539);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        thumb: __WEBPACK_IMPORTED_MODULE_1__PeopleRowThumb__["a" /* default */],
        actor: __WEBPACK_IMPORTED_MODULE_2__PeopleRowActor__["a" /* default */]
    },
    props: {
        'actorsPerLine': {
            type: Object
        },
        'numberOfActorsPerLine': {
            type: Number
        },
        'matchedSize': {
            type: String
        },
        'isSameLineFn': {
            type: Function
        },
        'isSameActorFn': {
            type: Function
        }
    },
    data: function data() {
        return {
            actor: {}
        };
    },

    methods: {
        anchorCollapseName: function anchorCollapseName() {
            return '#' + this.actorsPerLine.line;
        },
        selectActor: function selectActor(index) {
            //alert(this.actorsPerLine.scrollTop);
            //https://stackoverflow.com/questions/871399/cross-browser-method-for-detecting-the-scrolltop-of-the-browser-window#872537
            var currentScrollTop = document.body.scrollTop || document.documentElement.scrollTop;
            if (this.actorsPerLine.lineIndex != null) {
                var scrollTop = this.actorsPerLine.scrollTop;
                console.log("Scroll to " + scrollTop + " / current scrollTop " + currentScrollTop);
                window.scrollTo(0, 150 + this.actorsPerLine.lineIndex * 282);
            }

            this.actor = this.actorsPerLine.actors[index];
            if (this.actor.pv_id > -1) {
                __WEBPACK_IMPORTED_MODULE_0__main__["eventBus"].$emit('selectActor', { line: this.actorsPerLine.line, actor: this.actor });
            }
        }
    }
});

/***/ }),

/***/ 161:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        'collapseName': {
            type: String
        },
        'numberOfActorsPerLine': {
            type: Number
        },
        'actor': {
            type: Object
        },
        'isSameActorFn': {
            type: Function
        }
    },
    data: function data() {
        return {};
    },

    computed: {
        name: function name() {
            return this.actor.pv_vorname + '<br/>' + this.actor.pv_nachname;
        }
    },
    mounted: function mounted() {
        $('#' + this.actor.pv_id).on("toggle.collapse", this.toggleCollapse);
    },

    methods: {
        thumbId: function thumbId() {
            return 'thumb_' + this.actor.pv_id;
        },
        toggleCollapse: function toggleCollapse() {
            console.log(this.anchorCollapseName());
            $(this.anchorCollapseName()).collapse('toggle');
        },
        anchorCollapseName: function anchorCollapseName() {
            return '#' + this.collapseName;
        },
        widthClass: function widthClass() {
            return 'width-' + this.numberOfActorsPerLine;
        },
        display: function display() {
            if (this.actor !== null) {
                if (this.actor.pv_id < 0) {
                    return 'none';
                } else {
                    return '';
                }
            } else {
                return 'none';
            }

            if (this.actor.pv_id < 0) {} else {
                return '';
            }
        },
        showTriangle: function showTriangle() {
            if (this.actor !== null) {
                if (this.actor.pv_id < 0) {
                    return false;
                } else {
                    return this.isSameActorFn(this.actor.pv_id);
                }
            } else {
                return false;
            }
        }
    }
});

/***/ }),

/***/ 162:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PeopleDetail__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(57);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        peopleDetail: __WEBPACK_IMPORTED_MODULE_0__PeopleDetail__["a" /* default */]
    },
    props: {
        'collapseName': {
            type: String
        },
        'actor': {
            type: Object
        },
        'matchedSize': {
            type: String
        },
        'isSameLineFn': {
            type: Function
        },
        'isSameActorFn': {
            type: Function
        }
    },
    data: function data() {
        return {
            details: [],
            medien: [],
            auftrittsarten: [],
            auftritte: []
        };
    },

    computed: {
        name: function name() {
            var _this = this;

            if (this.actor != null && this.actor.pv_id > -1) {
                //console.log("Load new Actor Details for actor " + this.actor.pv_id);
                //this.$http.get(url.scheme + '://service.heimanns-agentur.de/api/detail/' + this.actor.pv_id)
                this.$http.get(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].scheme + '://relaunch2018.heimanns-agentur.de/api/detail/' + this.actor.pv_id).then(function (response) {
                    return response.json();
                }).then(function (data) {
                    _this.details = data.details;
                    _this.medien = data.medien;
                    _this.auftrittsarten = data.auftrittsarten;
                    _this.auftritte = data.auftritte;
                    //console.log("All Details for actor " + this.actor.pv_id + " fetched from DB");
                    //console.log("Details: " + JSON.stringify(this.details));
                });
                return this.actor.pv_vorname + ' ' + this.actor.pv_nachname;
            } else {
                return "Name is undefined";
            }
        }
    },
    methods: {
        anchorCollapseName: function anchorCollapseName() {
            return '#' + this.collapseName;
        },
        urlPdf: function urlPdf() {
            return __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].scheme + '://relaunch2018.heimanns-agentur.de/pdf/detailseite_pdf.php?id=' + this.actor.pv_id;
        },
        doSomethingOnHide: function doSomethingOnHide(event) {
            //console.log("Hide " + this.collapseName);
            if (this.isSameLineFn(this.collapseName)) {
                //console.log("same line " + this.collapseName + " with actor: " + this.actor.pv_id);
                if (!this.isSameActorFn(this.actor.pv_id)) {
                    //console.log("preventDefault bei " + this.collapseName + " actor: " + this.actor.pv_id);
                    return false;
                }
            }
        },
        resetActor: function resetActor() {
            //console.log("Close Actor");
            window.scrollBy(0, -86);
            __WEBPACK_IMPORTED_MODULE_1__main__["eventBus"].$emit('selectActor', { line: this.collapseName, actor: this.actor });
        }
    },
    mounted: function mounted() {
        var matched = this.matchedSize;

        $(this.anchorCollapseName()).on("hide.bs.collapse", this.doSomethingOnHide);
        $(this.anchorCollapseName()).on("hidden.bs.collapse", function (e) {
            window.scrollBy(0, -280);
        });
        $(this.anchorCollapseName()).on('shown.bs.collapse', function (e) {
            //https://stackoverflow.com/questions/28433178/scrollintoview-preventing-other-listeners-from-triggering
            e.target.scrollIntoView({ behaviour: 'smooth', block: 'start' });

            //var viewportH = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);

            if (matched === 'xs' || matched === 'sm') {

                window.scrollBy(0, -66); // Adjust scrolling with a negative value here
            } else {
                window.scrollBy(0, -100); // Adjust scrolling with a negative value here
            }
        });
    }
});

/***/ }),

/***/ 163:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MyLightbox__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PeopleInfo__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(57);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//import Lightbox from 'vue-image-lightbox'




/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        peopleInfo: __WEBPACK_IMPORTED_MODULE_1__PeopleInfo__["a" /* default */],
        Lightbox: __WEBPACK_IMPORTED_MODULE_0__MyLightbox__["a" /* default */]
        //Lightbox 
    },
    props: {
        'actor': {
            type: Object
        },
        'details': {
            type: Array
        },
        'matchedSize': {
            type: String
        },
        'medien': {
            type: Array,
            default: []
        },
        'auftrittsarten': {
            type: Array
        },
        'auftritte': {
            type: Array
        }
    },
    computed: {
        imageList: function imageList() {
            var _this = this;

            //this.$refs.mySwiper.swiper.update();
            //console.log("Build imageList");
            var medienlist = [];
            this.medien.forEach(function (element) {
                if (_this.actor.pv_id === element.pv_id) {
                    medienlist.push({
                        id: element.pm_id,
                        thumb: element.pm_bild,
                        src: element.pm_bild,
                        caption: '© ' + element.pm_copyright
                    });
                }
            });
            //console.log(JSON.stringify(medienlist));
            //this.$refs.mySwiper.swiper.update();
            return medienlist;
        },
        height: function height() {
            return {
                height: this.imageHeight
            };
        },
        imageHeight: function imageHeight() {
            if (this.matchedSize === 'xs') {
                return '250px';
            } else {
                return '400px';
            }
        }
    },
    watch: {
        medien: function medien() {
            //console.log("Watch medien");
            this.$refs.mySwiper.swiper.removeAllSlides();
            this.$refs.mySwiper.swiper.update();
        },
        imageList: function imageList() {
            //console.log("Watch imageList: " + this.imageList.length + " - medien " + this.medien.length);
            var sw = this.$refs.mySwiper.swiper;
            setTimeout(function () {
                sw.update();
            }, 500);
            this.$refs.mySwiper.swiper.slideTo(0);
            //console.log("slides: " + JSON.stringify(this.$refs.mySwiper.swiper.slides[0]));
            //console.log("activeIndex: " + this.$refs.mySwiper.swiper.activeIndex);
            //this.$refs.mySwiper.swiper.isBeginning = true;
            //this.$refs.mySwiper.swiper.isEnd = false;
            //this.$refs.mySwiper.swiper.allowSlideNext(true);
        }
    },
    data: function data() {
        return {
            medienlist: [],
            swiperOption: {
                slidesPerView: 'auto',
                //loop: true,
                //loopedSlides: this.medien.length,
                centeredSlides: false,
                //effect: 'slide',
                spaceBetween: 10,
                //keyboard: {
                //    enabled: true,
                //},
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
                autoHeight: true,
                watchSlidesProgress: true,
                watchSlidesVisibility: true,
                on: {
                    init: function init() {
                        //console.log('swiper initialized');
                    },
                    slideChange: function slideChange(e) {
                        //alert('Slide change');
                        //console.log("Slide change, isend = " + this.isEnd);
                    }
                }
            }
        };
    },

    methods: {
        openGallery: function openGallery(index, slide) {
            //alert("zoom in " + JSON.stringify(slide));
            this.$refs.lightbox.showImage(index);
        },
        urlVideoLink: function urlVideoLink() {
            return this.details[0].videolink != "" ? this.details[0].videolink : "";
        },
        urlPdf: function urlPdf() {
            return __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].scheme + '://relaunch2018.heimanns-agentur.de/pdf/detailseite_pdf.php?id=' + this.actor.pv_id;
        },
        hasAuftrittsart: function hasAuftrittsart(art) {
            var result = false;
            this.auftrittsarten.forEach(function (element) {
                if (element.pa_auftrittsart === art) {
                    result = true;
                }
            });
            return result;
        },
        filterByAuftrittsart: function filterByAuftrittsart(art) {
            var result = this.auftritte.filter(function (element) {
                return element.pa_auftrittsart === art;
            });
            //console.log("art: " + art  + " " + JSON.stringify(result.length));
            return result;
        },
        showSonstOnLeftColumn: function showSonstOnLeftColumn() {
            var result = true;
            if (this.hasAuftrittsart("theat") && this.hasAuftrittsart("film")) {
                //console.log("theat: " + this.filterByAuftrittsart("theat").length);
                //console.log("film: " + this.filterByAuftrittsart("film").length);
                if (this.filterByAuftrittsart("theat").length >= this.filterByAuftrittsart("film").length) {
                    result = false;
                }
            }
            //console.log("showSonstOnLeftColumn: " + result);
            return result;
        },
        filterHtml: function filterHtml(html) {
            //console.log("Rein: " + html);
            var regex = new RegExp('&sect;', 'g');
            var result = html.replace(regex, ' ');

            regex = new RegExp('<br />', 'g');
            result = result.replace(regex, '<br style="line-height:25px;"/>');

            regex = new RegExp('&lt;br /&gt;', 'g');
            result = result.replace(regex, '<br style="line-height:25px;"/>');

            regex = new RegExp('\n', 'g');
            result = result.replace(regex, '<br style="line-height:25px;"/>');

            //console.log("Raus: " + result);  
            return result;
        }
    }

});

/***/ }),

/***/ 164:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(57);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    images: {
      type: Array,
      required: true
    },

    actor: {
      type: Object
    },

    showLightBox: {
      type: Boolean,
      default: true
    },

    startAt: {
      type: Number,
      default: 0
    },

    nThumbs: {
      type: Number,
      default: 7
    },

    showThumbs: {
      type: Boolean,
      default: true
    },

    // Mode
    autoPlay: {
      type: Boolean,
      default: false
    },

    autoPlayTime: {
      type: Number,
      default: 3000
    },

    siteLoading: {
      default: null
    },

    showCaption: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      select: this.startAt,
      thumbSelect: this.startAt,
      lightBoxOn: this.showLightBox,
      displayThumbs: this.images.slice(0, this.nThumbs),
      timer: null,

      beginThumbIndex: 0
    };
  },


  computed: {
    countImages: function countImages() {
      return this.images.length;
    },
    imagesThumb: function imagesThumb() {
      var _this = this;

      if (this.siteLoading) {
        return this.displayThumbs.map(function (_ref) {
          var thumb = _ref.thumb;
          return {
            src: thumb,
            loading: _this.siteLoading,
            error: _this.siteLoading
          };
        });
      }

      return this.displayThumbs.map(function (_ref2) {
        var thumb = _ref2.thumb;
        return thumb;
      });
    }
  },

  watch: {
    startAt: function startAt() {
      this.$set(this, 'select', this.startAt);
      this.$set(this, 'thumbSelect', this.startAt);
    },
    images: function images() {
      this.$set(this, 'displayThumbs', this.images.slice(0, this.nThumbs));
    },
    select: function select() {
      var halfDown = Math.floor(this.nThumbs / 2);
      var mod = 1 - this.nThumbs % 2;

      if (this.select <= halfDown) {
        this.$set(this, 'beginThumbIndex', 0);
        this.$set(this, 'thumbSelect', this.select);
        this.$set(this, 'displayThumbs', this.images.slice(0, this.nThumbs));
        return;
      }

      if (this.select >= this.countImages - halfDown) {
        this.$set(this, 'beginThumbIndex', this.countImages - this.nThumbs);
        this.$set(this, 'thumbSelect', this.nThumbs - (this.countImages - this.select));
        this.$set(this, 'displayThumbs', this.images.slice(-this.nThumbs));
        return;
      }

      this.$set(this, 'beginThumbIndex', this.select - halfDown + mod);
      this.$set(this, 'thumbSelect', halfDown - mod);
      this.$set(this, 'displayThumbs', this.images.slice(this.select - halfDown + mod, this.select + halfDown + 1));
    },
    lightBoxOn: function lightBoxOn(value) {
      if (document != null) {
        if (value) {
          document.getElementsByTagName('body')[0].classList.add('vue-lb-open');
        } else {
          document.getElementsByTagName('body')[0].classList.remove('vue-lb-open');
        }
      }
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    if (this.autoPlay) {
      this.timer = setInterval(function () {
        _this2.nextImage();
      }, this.autoPlayTime);
    }
  },


  methods: {
    showImage: function showImage(index) {
      document.addEventListener('keydown', this.addKeyEvent);

      this.$set(this, 'lightBoxOn', true);
      this.$set(this, 'select', index);
    },
    printUrl: function printUrl() {
      console.log("Actor: " + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.actor));
      console.log("Image: " + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.images[this.select]));
      return this.images[this.select].thumb;
    },
    addKeyEvent: function addKeyEvent(event) {
      if (event.keyCode === 37) this.previousImage();
      if (event.keyCode === 39) this.nextImage();
      if (event.keyCode === 27) this.closeLightBox();
    },
    closeLightBox: function closeLightBox() {
      this.$set(this, 'lightBoxOn', false);
      document.removeEventListener('keydown', this.addKeyEvent);
    },
    nextImage: function nextImage() {
      this.$set(this, 'select', (this.select + 1) % this.countImages);
    },
    previousImage: function previousImage() {
      this.$set(this, 'select', (this.select - 1 + this.countImages) % this.countImages);
    },
    downloadImage: function downloadImage() {
      var imageUrl = this.images[this.select].src;
      //console.log(JSON.stringify(imageUrl));
      var lastdot = imageUrl.lastIndexOf(".");
      //console.log("lastdot " + lastdot);
      var ext = imageUrl.substr(lastdot + 1);
      var filename = 'Heimanns_Agentur_' + this.actor.pv_vorname.replace(' ', '_') + "_" + this.actor.pv_nachname.replace(' ', '_') + '_' + (this.select + 1) + '.' + ext;

      //console.log("Download " + filename + "." + ext + " from url " + imageUrl);

      var requestString = __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].scheme + '://relaunch2018.heimanns-agentur.de/download/download.php?' + 'filename=' + encodeURIComponent(filename) + '&imageUrl=' + encodeURIComponent(imageUrl) + '&ext=' + ext;

      console.log("Request: " + requestString);

      window.open(requestString, '_blank');
      /*this.$http.get(requestString)
        .then(response => {
            return response;
        });*/
    }
  },

  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('keydown', this.addKeyEvent);

    if (this.autoPlay) {
      clearInterval(this.timer);
    }
  }
});

/***/ }),

/***/ 166:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        'infos': Array
    },
    methods: {
        filterHtml: function filterHtml(html) {
            //console.log(html);
            var regex = new RegExp('<br />', 'g');
            var result = html.replace(regex, '<br/><br/>');

            regex = new RegExp('<br>', 'g');
            result = result.replace(regex, '<br/><br/>');

            regex = new RegExp('&lt;br /&gt;', 'g');
            result = result.replace(regex, '<br/><br/>');

            regex = new RegExp('&lt;br &gt;', 'g');
            result = result.replace(regex, '<br/><br/>');

            regex = new RegExp('<br/><br/><br/><br/>', 'g');
            result = result.replace(regex, '<br/><br/>');

            regex = new RegExp('<br/><br/><br/>', 'g');
            result = result.replace(regex, '<br/><br/>');

            regex = new RegExp('\n', 'g');
            result = result.replace(regex, '<br/>');

            //console.log(result);  
            return result;
            /*            var result = html.replace("<br />", "\n");
                        result = result.replace("<br/>", "\n");
                        result = result.replace("&lt;br /&gt;", "\n");   
                        return result; */
        }
    }
});

/***/ }),

/***/ 167:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Facebook__ = __webpack_require__(556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_js__ = __webpack_require__(57);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        'actorsPerLine': {
            type: String
        }
    },
    components: {
        facebook: __WEBPACK_IMPORTED_MODULE_0__Facebook__["a" /* default */]
    },
    data: function data() {
        return {
            facebookWidth: 500,
            feeds: []
        };
    },
    mounted: function mounted() {
        var externalScript = document.createElement('script');
        //externalScript.setAttribute('src', 'https://assets.juicer.io/embed.js')
        document.head.appendChild(externalScript);
    },
    created: function created() {
        var _this = this;

        this.$http.get(__WEBPACK_IMPORTED_MODULE_1__config_js__["a" /* default */].scheme + '://relaunch2018.heimanns-agentur.de/twitter/twitter.php?id=174592245925723&limit=12&out=intro,thumb,text,user').then(function (response) {
            return response.json();
        }).then(function (data) {
            _this.feeds = [];
            data.responseData.feed.entries.forEach(function (onefeed) {
                //console.log("Feed: " + JSON.stringify(onefeed));
                if (_this.feeds.length < 12) {
                    if (onefeed.content != "") {
                        _this.feeds.push(onefeed);
                    }
                }
            });

            //this.feeds = data.responseData.feed.entries;
            //console.log("Feeds " + JSON.stringify(this.feeds));
        });
    },

    methods: {
        matchMedia: function matchMedia(alias, matches) {
            if (alias === 'xs' && matches) {
                this.facebookWidth = '360';
            } else if (alias === 'sm' && matches) {
                this.facebookWidth = '500';
            } else if (alias === 'md' && matches) {
                this.facebookWidth = '500';
            } else if (alias === 'lg' && matches) {
                this.facebookWidth = '500';
            } else if (alias === 'xl' && matches) {
                this.facebookWidth = '500';
            }
        }
    }
});

/***/ }),

/***/ 168:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        'feed': {
            type: Object
        }
    },
    data: function data() {
        return {};
    },

    computed: {
        linkifiedContent: function linkifiedContent() {
            var linkified = this.linkify(this.feed.content.replace(/<(?:.|\n)*?>/gm, ' '));
            //if (linkified.length < 260) {
            return linkified;
            //} else {
            //    return linkified.substr(0,260) + "...";
            //}
        }
    },
    methods: {
        linkify: function linkify(inputText) {
            //https://stackoverflow.com/questions/37684/how-to-replace-plain-urls-with-links
            //URLs starting with http://, https://, or ftp://
            var replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
            var replacedText = inputText.replace(replacePattern1, '<a href="$1" target="_blank">$1</a>');

            //URLs starting with www. (without // before it, or it'd re-link the ones done above)
            var replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
            replacedText = replacedText.replace(replacePattern2, '$1<a href="http://$2" target="_blank">$2</a>');

            //Change email addresses to mailto:: links
            var replacePattern3 = /(\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,6})/gim;
            replacedText = replacedText.replace(replacePattern3, '<a href="mailto:$1">$1</a>');

            return replacedText;
        },
        formatDate: function formatDate() {
            if (this.feed.publishedDate) {
                return __WEBPACK_IMPORTED_MODULE_0_moment___default()(String(this.feed.publishedDate)).format('DD.MM.YYYY hh:mm');
            } else {
                return "";
            }
        }
    }
});

/***/ }),

/***/ 291:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ 292:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(57);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            name: "",
            email: "",
            betreff: "",
            nachricht: "",
            isSubmitted: false,
            isSending: false,
            wasResponseError: false,
            lastMessage: {},
            isAgreed: false
        };
    },

    validations: {
        name: {
            required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
        },
        email: {
            required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
            email: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["email"]
        },
        betreff: {
            required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
        },
        nachricht: {
            required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"]
        }
    },
    methods: {
        sendMail: function sendMail() {
            var _this = this;

            var message = {
                name: this.name,
                email: this.email,
                betreff: this.betreff,
                nachricht: this.nachricht
            };

            if (!this.wasResponseError && this.lastMessage.name === message.name && this.lastMessage.email === message.email && this.lastMessage.betreff === message.betreff && this.lastMessage.nachricht === message.nachricht) {
                //alert("Mehrfachsendung");
                return;
            }

            this.lastMessage = message;

            this.isSending = true;
            this.isSubmitted = false;
            this.wasResponseError = false;
            //this.$http.post(url.scheme + '://service.heimanns-agentur.de/api/contact', message)
            this.$http.post(__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].scheme + '://relaunch2018.heimanns-agentur.de/api/contact', message).then(function (response) {
                return response.json();
            }, function (error) {
                _this.wasResponseError = true;
                _this.isSending = false;
            }).then(function (data) {
                console.log("Posted data: " + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
                if (!_this.wasResponseError) {
                    _this.isSubmitted = true;
                }
                _this.isSending = false;
            });
        }
    }
});

/***/ }),

/***/ 293:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ 294:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ 295:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__People__ = __webpack_require__(158);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        sectionPeople: __WEBPACK_IMPORTED_MODULE_0__People__["a" /* default */]
    }
});

/***/ }),

/***/ 296:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ 315:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(316);
module.exports = __webpack_require__(81);


/***/ }),

/***/ 528:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 530:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(157);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_052e8f1a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(602);
function injectStyle (ssrContext) {
  __webpack_require__(531)
}
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_052e8f1a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 531:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 532:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 533:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PeopleRow_vue__ = __webpack_require__(160);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_421f76ce_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PeopleRow_vue__ = __webpack_require__(552);
function injectStyle (ssrContext) {
  __webpack_require__(534)
}
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PeopleRow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_421f76ce_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PeopleRow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 534:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 535:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PeopleRowThumb_vue__ = __webpack_require__(161);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_347d0d4a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PeopleRowThumb_vue__ = __webpack_require__(537);
function injectStyle (ssrContext) {
  __webpack_require__(536)
}
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-347d0d4a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PeopleRowThumb_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_347d0d4a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PeopleRowThumb_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 536:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 537:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{class:_vm.widthClass(),staticStyle:{"padding-bottom":"0px"},attrs:{"id":_vm.thumbId()}},[_c('div',{staticClass:"avatar",style:({display: _vm.display()})},[_c('a',{attrs:{"id":_vm.actor.pv_id,"data-toggle":"collapse","href":_vm.anchorCollapseName()}},[_c('img',{staticClass:"thumb z-depth-1",staticStyle:{"min-width":"164px"},attrs:{"src":_vm.actor.pv_bild,"alt":_vm.name}})])]),_vm._v(" "),_c('a',{attrs:{"data-toggle":"collapse","href":_vm.anchorCollapseName()}},[_c('h5',{staticClass:"my-1 font-bold text-center heimanns-text-color",domProps:{"innerHTML":_vm._s(_vm.name)}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showTriangle()),expression:"showTriangle()"}],staticClass:"text-center",style:({display: _vm.display()})},[_c('img',{staticStyle:{"width":"28px"},attrs:{"src":__webpack_require__(538)}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 538:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAeCAYAAABe3VzdAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3ZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQwIDc5LjE2MDMwMiwgMjAxNy8wMy8wMi0xNjo1OTozOCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDowNThiYjEyYy1kY2Q0LTRlMGMtYjc0OS1iZDI2MWY3Nzg1NmQiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NDg3OTBCRkExMENFMTFFOEI5NjE4REM0RUE4NUVGRjIiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NDg3OTBCRjkxMENFMTFFOEI5NjE4REM0RUE4NUVGRjIiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIEVsZW1lbnRzIDE2LjAgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDozQzM3QUM5Q0Q5RTQxMUU3QkJFRkE5NTAwMTUwNUNCNiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDozQzM3QUM5REQ5RTQxMUU3QkJFRkE5NTAwMTUwNUNCNiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PptINL0AAAMtSURBVHjazFc7bNNQFPUncey4iR1/QjO0CUORWAoSEkIIKkBiAgmJhYkFFjZGpK6IGQnWMvIZKrEAYghCIAoSMDEyIPKxnaQ/OjAUNYV7K1704vrZTuskvVFk+z1fv/Pu59z7+Lmz57ha/adQnq5sc5TgGF7JOHmmxa8TpYdjQd9hzeEYjwCjJGyRqEVZmwsDRQyGV75crghBlmABHLUIcYDQGwjbDM5FbXbQbwpxXhzUgnFA0nEf5OZAC8ZZOMzKruvMr6+vfacXYVk17Fu0JBKDqF9v1I5PHpr8IkmZVGe587JoFy8nEbvCftxGrANA5IJeqCI4HLct+xJY8w5Lh2VZeoxcRV3XeV3T/4aB29j4xeM/aBx1u1tbS7pemOm5hee5TEa+4HpOdXqqXKd1yT3R9c/R8z0LElfQLsF78meFAI57Le+BaVon/XOSJAkF3XgF+vm4mc2Mwb1mZbPZuFoqlRZFMcWzdNfWVr8Zhnks0Rj0U09QsENSTJmm+TgMHAqAm221vYXEALJqsl/yufwHRcnKcRaxreJNx2le3xPAIEBR9AA08gKSYjruIqIochCnC/V6bWaQur8DMA5X0ZtA+kAaGdQSsixLmqa/j8OpTBdHZVujWT9tWfY9pJG9iKZpk1klWx3Eijs86OcovyBfIV0YBfOrArKfyqCq6mHXc1O5XO4t6x2al/sABpmbvLzd7X4GF5WTaKEURT7juM4nLa/98FuOEDh57qvF/kaU3LfarUdQZ28k2ef9BllZXa7AOiuRWRyUueQZ6QGSIlFw/12t5nL5pUgG4Hg2WSMt2HbxNZQtcRjdMoSz2e60jk6oE4sDVxK0INIC0sMwW3og8WuO27wVm6jJM9IB0sLQzxyCwFmm/RBK52zgPOlW+sjYc++Ca8+P6mCUyWRS0E++ASxSoIvpsyyQ8cWibc+P+vQGCWOpWfVd1KnOAjJ+nkqlx3LMhCp1ymu593cBJO7FtMf058YocJa5DX3mlV0WhHR/ZhSMI9yYBftL6DOfQtKUelmMaY7pzh0QgT5TgX7zI+aGCL85SPMn6XRa5A6QyLKi/9ncPPFPgAEAw/ypzKePrOEAAAAASUVORK5CYII="

/***/ }),

/***/ 539:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PeopleRowActor_vue__ = __webpack_require__(162);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ca9b753_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PeopleRowActor_vue__ = __webpack_require__(551);
function injectStyle (ssrContext) {
  __webpack_require__(540)
}
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1ca9b753"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PeopleRowActor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ca9b753_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PeopleRowActor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 540:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 541:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PeopleDetail_vue__ = __webpack_require__(163);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c35fb86_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PeopleDetail_vue__ = __webpack_require__(550);
function injectStyle (ssrContext) {
  __webpack_require__(542)
}
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5c35fb86"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PeopleDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c35fb86_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PeopleDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 542:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 543:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyLightbox_vue__ = __webpack_require__(164);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4dd22246_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyLightbox_vue__ = __webpack_require__(546);
function injectStyle (ssrContext) {
  __webpack_require__(544)
}
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4dd22246"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyLightbox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4dd22246_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyLightbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 544:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 546:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":function($event){$event.stopPropagation();_vm.closeLightBox($event)}}},[(_vm.images && _vm.images.length > 0)?_c('v-touch',{directives:[{name:"show",rawName:"v-show",value:(_vm.lightBoxOn),expression:"lightBoxOn"}],staticClass:"vue-lb-container",on:{"swiperight":function($event){_vm.previousImage()},"swipeleft":function($event){_vm.nextImage()}}},[_c('div',{staticClass:"vue-lb-content"},[_c('div',{staticClass:"vue-lb-header show-xs"},[_c('div',{staticClass:"mt-1 text-center",staticStyle:{"width":"100%"}},[_c('a',{staticClass:"btn btn-primary btn-sm btn-rounded",attrs:{"target":"_blank","href":_vm.printUrl()}},[_c('i',{staticClass:"fa fa-print hide-xs",staticStyle:{"color":"white","margin":"-3px 3px 0px -5px"}}),_vm._v(" "),_c('span',{directives:[{name:"lang",rawName:"v-lang.drucken",modifiers:{"drucken":true}}]},[_vm._v("Print")])]),_vm._v(" "),_c('a',{staticClass:"btn btn-primary btn-sm btn-rounded",attrs:{"target":"_blank"},on:{"click":_vm.downloadImage}},[_c('i',{staticClass:"fa fa-download hide-xs",staticStyle:{"color":"white","margin":"-3px 3px 0px -5px"}}),_vm._v(" "),_c('span',{directives:[{name:"lang",rawName:"v-lang.download",modifiers:{"download":true}}]},[_vm._v("Download")])])]),_vm._v(" "),_c('button',{staticClass:"vue-lb-button-close",attrs:{"type":"button","title":"Close (Esc)"}},[_c('span',[_c('svg',{staticStyle:{"enable-background":"new 0 0 512 512"},attrs:{"fill":"white","x":"0px","y":"0px","width":"100%","height":"100%","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M443.6,387.1L312.4,255.4l131.5-130c5.4-5.4,5.4-14.2,0-19.6l-37.4-37.6c-2.6-2.6-6.1-4-9.8-4c-3.7,0-7.2,1.5-9.8,4 L256,197.8L124.9,68.3c-2.6-2.6-6.1-4-9.8-4c-3.7,0-7.2,1.5-9.8,4L68,105.9c-5.4,5.4-5.4,14.2,0,19.6l131.5,130L68.4,387.1 c-2.6,2.6-4.1,6.1-4.1,9.8c0,3.7,1.4,7.2,4.1,9.8l37.4,37.6c2.7,2.7,6.2,4.1,9.8,4.1c3.5,0,7.1-1.3,9.8-4.1L256,313.1l130.7,131.1 c2.7,2.7,6.2,4.1,9.8,4.1c3.5,0,7.1-1.3,9.8-4.1l37.4-37.6c2.6-2.6,4.1-6.1,4.1-9.8C447.7,393.2,446.2,389.7,443.6,387.1z"}})])])])]),_vm._v(" "),_c('div',{staticClass:"vue-lb-figure",on:{"click":function($event){$event.stopPropagation();}}},[_c('transition',{attrs:{"mode":"out-in","name":"fade"}},[_c('img',{key:_vm.images[_vm.select].src,staticClass:"vue-lb-modal-image",attrs:{"src":_vm.images[_vm.select].src}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showCaption),expression:"showCaption"}],staticClass:"vue-lb-info",domProps:{"innerHTML":_vm._s(_vm.images[_vm.select].caption)}}),_vm._v(" "),_c('div',{staticClass:"vue-lb-footer"},[_c('div',{staticClass:"vue-lb-footer-info"}),_vm._v(" "),_c('div',{staticClass:"vue-lb-footer-count"},[_vm._v("\n            "+_vm._s(_vm.select + 1)+"/"+_vm._s(_vm.countImages)+"\n          ")])])],1)]),_vm._v(" "),_c('div',{staticClass:"vue-lb-thumbnail-wrapper"},[(_vm.showThumbs)?_c('div',{staticClass:"vue-lb-thumbnail"},[(_vm.images.length > 1)?_c('button',{staticClass:"vue-lb-thumbnail-arrow vue-lb-thumbnail-left",attrs:{"type":"button","title":"Previous"},on:{"click":function($event){$event.stopPropagation();_vm.previousImage()}}},[_c('span',[_c('svg',{attrs:{"fill":"white","x":"0px","y":"0px","width":"100%","height":"100%","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M213.7,256L213.7,256L213.7,256L380.9,81.9c4.2-4.3,4.1-11.4-0.2-15.8l-29.9-30.6c-4.3-4.4-11.3-4.5-15.5-0.2L131.1,247.9 c-2.2,2.2-3.2,5.2-3,8.1c-0.1,3,0.9,5.9,3,8.1l204.2,212.7c4.2,4.3,11.2,4.2,15.5-0.2l29.9-30.6c4.3-4.4,4.4-11.5,0.2-15.8 L213.7,256z"}})])])]):_vm._e(),_vm._v(" "),_vm._l((_vm.imagesThumb),function(image,index){return _c('div',{directives:[{name:"lazy",rawName:"v-lazy:background-image",value:(image),expression:"image",arg:"background-image"}],key:index,class:'vue-lb-modal-thumbnail' + (_vm.thumbSelect === index ? '-active' : ''),on:{"click":function($event){$event.stopPropagation();_vm.showImage(index + _vm.beginThumbIndex)}}})}),_vm._v(" "),(_vm.images.length > 1)?_c('button',{staticClass:"vue-lb-thumbnail-arrow vue-lb-thumbnail-right",attrs:{"type":"button","title":"Next"},on:{"click":function($event){$event.stopPropagation();_vm.nextImage()}}},[_c('span',[_c('svg',{attrs:{"fill":"white","x":"0px","y":"0px","width":"100%","height":"100%","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M298.3,256L298.3,256L298.3,256L131.1,81.9c-4.2-4.3-4.1-11.4,0.2-15.8l29.9-30.6c4.3-4.4,11.3-4.5,15.5-0.2l204.2,212.7 c2.2,2.2,3.2,5.2,3,8.1c0.1,3-0.9,5.9-3,8.1L176.7,476.8c-4.2,4.3-11.2,4.2-15.5-0.2L131.3,446c-4.3-4.4-4.4-11.5-0.2-15.8 L298.3,256z"}})])])]):_vm._e()],2):_vm._e()]),_vm._v(" "),(_vm.images.length > 1)?_c('button',{staticClass:"vue-lb-arrow vue-lb-left",attrs:{"type":"button","title":"Previous"},on:{"click":function($event){$event.stopPropagation();_vm.previousImage()}}},[_c('span',[_c('svg',{attrs:{"fill":"white","x":"0px","y":"0px","width":"100%","height":"100%","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M213.7,256L213.7,256L213.7,256L380.9,81.9c4.2-4.3,4.1-11.4-0.2-15.8l-29.9-30.6c-4.3-4.4-11.3-4.5-15.5-0.2L131.1,247.9 c-2.2,2.2-3.2,5.2-3,8.1c-0.1,3,0.9,5.9,3,8.1l204.2,212.7c4.2,4.3,11.2,4.2,15.5-0.2l29.9-30.6c4.3-4.4,4.4-11.5,0.2-15.8 L213.7,256z"}})])])]):_vm._e(),_vm._v(" "),(_vm.images.length > 1)?_c('button',{staticClass:"vue-lb-arrow vue-lb-right",attrs:{"type":"button","title":"Next"},on:{"click":function($event){$event.stopPropagation();_vm.nextImage()}}},[_c('span',[_c('svg',{attrs:{"fill":"white","x":"0px","y":"0px","width":"100%","height":"100%","viewBox":"0 0 512 512","xml:space":"preserve"}},[_c('path',{attrs:{"d":"M298.3,256L298.3,256L298.3,256L131.1,81.9c-4.2-4.3-4.1-11.4,0.2-15.8l29.9-30.6c4.3-4.4,11.3-4.5,15.5-0.2l204.2,212.7 c2.2,2.2,3.2,5.2,3,8.1c0.1,3-0.9,5.9-3,8.1L176.7,476.8c-4.2,4.3-11.2,4.2-15.5-0.2L131.3,446c-4.3-4.4-4.4-11.5-0.2-15.8 L298.3,256z"}})])])]):_vm._e()]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 547:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PeopleInfo_vue__ = __webpack_require__(166);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dde96018_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PeopleInfo_vue__ = __webpack_require__(549);
function injectStyle (ssrContext) {
  __webpack_require__(548)
}
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-dde96018"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PeopleInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dde96018_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PeopleInfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 548:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 549:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"table table-responsive vita"},_vm._l((_vm.infos),function(info){return _c('tbody',{key:info.id},[_c('tr',[_c('td',{attrs:{"width":"15%"}},[_c('span',[_vm._v(_vm._s(info.pa_zeit))])]),_vm._v(" "),_c('td',[((info.pa_ueberschrift !== ''))?_c('span',{staticStyle:{"font-weight":"bold"},domProps:{"innerHTML":_vm._s(_vm.filterHtml(info.pa_ueberschrift))}}):_vm._e(),_vm._v(" "),((info.pa_ueberschrift !== ''))?_c('br'):_vm._e(),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.filterHtml(info.pa_text))}})])])])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 550:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:((_vm.actor != null && _vm.actor.pv_id > 0)),expression:"(actor != null && actor.pv_id > 0)"}]},[_c('swiper',{ref:"mySwiper",staticStyle:{"margin":"0px","padding":"0px"},attrs:{"options":_vm.swiperOption}},[_vm._l((_vm.imageList),function(slide,index){return _c('swiper-slide',{key:slide.id,staticClass:"mySwipe",style:(_vm.height),nativeOn:{"click":function($event){_vm.openGallery(index, slide)}}},[_c('img',{staticStyle:{"height":"100%"},attrs:{"src":slide.src}})])}),_vm._v(" "),_c('div',{staticClass:"swiper-button-prev",attrs:{"slot":"button-prev"},slot:"button-prev"}),_vm._v(" "),_c('div',{staticClass:"swiper-button-next",attrs:{"slot":"button-next"},slot:"button-next"})],2),_vm._v(" "),_c('lightbox',{ref:"lightbox",attrs:{"images":_vm.imageList,"show-caption":true,"show-light-box":false,"show-thumbs":true,"actor":_vm.actor}}),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row my-3"},[_c('div',{staticClass:"col-12 text-center"},[_c('span',[_c('a',{staticClass:"btn btn-primary btn-rounded",attrs:{"target":"_blank","href":_vm.urlVideoLink()}},[_c('i',{staticClass:"fa fa-film fa-2x",staticStyle:{"color":"white","margin":"-3px 3px 0px -5px"}}),_vm._v(" Showreel\n                        ")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-lg-6"},[_c('div',{staticClass:"card vita mb-4"},[_c('div',{staticClass:"card-header"},[_c('h4',{directives:[{name:"lang",rawName:"v-lang.vita",modifiers:{"vita":true}}],staticClass:"text-center lower-3"},[_vm._v("Vita")])]),_vm._v(" "),_c('a',{staticClass:"btn-floating btn-action grey lighten-2",attrs:{"target":"_blank","href":_vm.urlPdf()}},[_c('i',{staticClass:"fa fa-print fa-2x",staticStyle:{"color":"#0188c0"}})]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('table',{staticClass:"table table-responsive vita"},[_c('tbody',[_c('tr',[_c('td',{attrs:{"width":"30%"}},[_c('span',{directives:[{name:"lang",rawName:"v-lang.geburtsjahr",modifiers:{"geburtsjahr":true}}]},[_vm._v("Geburtsjahr")])]),_c('td',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.details[0].pv_geburtsjahr)}})])]),_vm._v(" "),_c('tr',[_c('td',[_c('span',{directives:[{name:"lang",rawName:"v-lang.nationalitaet",modifiers:{"nationalitaet":true}}]},[_vm._v("Nationalität")])]),_c('td',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.details[0].pv_nationalitaet)}})])]),_vm._v(" "),(_vm.details[0].pv_groesse !== 'NULL' && _vm.details[0].pv_groesse !== '')?_c('tr',[_c('td',[_c('span',{directives:[{name:"lang",rawName:"v-lang.groesse",modifiers:{"groesse":true}}]},[_vm._v("Größe")])]),_c('td',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.details[0].pv_groesse)}})])]):_vm._e(),_vm._v(" "),(_vm.details[0].pv_haarfarbe !== 'NULL' && _vm.details[0].pv_haarfarbe !== '')?_c('tr',[_c('td',[_c('span',{directives:[{name:"lang",rawName:"v-lang.haarfarbe",modifiers:{"haarfarbe":true}}]},[_vm._v("Haarfarbe")])]),_c('td',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.details[0].pv_haarfarbe)}})])]):_vm._e(),_vm._v(" "),(_vm.details[0].pv_augenfarbe !== 'NULL' && _vm.details[0].pv_augenfarbe !== '')?_c('tr',[_c('td',[_c('span',{directives:[{name:"lang",rawName:"v-lang.augenfarbe",modifiers:{"augenfarbe":true}}]},[_vm._v("Augenfarbe")])]),_c('td',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.details[0].pv_augenfarbe)}})])]):_vm._e(),_vm._v(" "),(_vm.details[0].pv_sprachen !== 'NULL' && _vm.details[0].pv_sprachen !== '')?_c('tr',[_c('td',[_c('span',{directives:[{name:"lang",rawName:"v-lang.sprachen",modifiers:{"sprachen":true}}]},[_vm._v("Sprachen")])]),_c('td',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.filterHtml(_vm.details[0].pv_sprachen))}})])]):_vm._e(),_vm._v(" "),(_vm.details[0].pv_dialekte !== 'NULL' && _vm.details[0].pv_dialekte !== '')?_c('tr',[_c('td',[_c('span',{directives:[{name:"lang",rawName:"v-lang.dialekte",modifiers:{"dialekte":true}}]},[_vm._v("Dialekte")])]),_c('td',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.details[0].pv_dialekte)}})])]):_vm._e(),_vm._v(" "),(_vm.details[0].pv_akzent !== 'NULL' && _vm.details[0].pv_akzent !== '')?_c('tr',[_c('td',[_c('span',{directives:[{name:"lang",rawName:"v-lang.akzent",modifiers:{"akzent":true}}]},[_vm._v("Akzent")])]),_c('td',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.details[0].pv_akzent)}})])]):_vm._e(),_vm._v(" "),(_vm.details[0].pv_fuehrerschein !== 'NULL' && _vm.details[0].pv_fuehrerschein !== '')?_c('tr',[_c('td',[_c('span',{directives:[{name:"lang",rawName:"v-lang.fuehrerschein",modifiers:{"fuehrerschein":true}}]},[_vm._v("Führerschein")])]),_c('td',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.details[0].pv_fuehrerschein)}})])]):_vm._e(),_vm._v(" "),(_vm.details[0].pv_sport !== 'NULL' && _vm.details[0].pv_sport !== '')?_c('tr',[_c('td',[_c('span',{directives:[{name:"lang",rawName:"v-lang.sport",modifiers:{"sport":true}}]},[_vm._v("Sport")])]),_c('td',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.filterHtml(_vm.details[0].pv_sport))}})])]):_vm._e(),_vm._v(" "),(_vm.details[0].pv_specials !== 'NULL' && _vm.details[0].pv_specials !== '')?_c('tr',[_c('td',[_c('span',{directives:[{name:"lang",rawName:"v-lang.specials",modifiers:{"specials":true}}]},[_vm._v("Specials")])]),_c('td',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.details[0].pv_specials)}})])]):_vm._e(),_vm._v(" "),(_vm.details[0].pv_musik !== 'NULL' && _vm.details[0].pv_musik !== '')?_c('tr',[_c('td',[_c('span',{directives:[{name:"lang",rawName:"v-lang.musik",modifiers:{"musik":true}}]},[_vm._v("Musik")])]),_c('td',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.details[0].pv_musik)}})])]):_vm._e(),_vm._v(" "),(_vm.details[0].pv_wohnort !== 'NULL' && _vm.details[0].pv_wohnort !== '')?_c('tr',[_c('td',[_c('span',{directives:[{name:"lang",rawName:"v-lang.wohnort",modifiers:{"wohnort":true}}]},[_vm._v("Wohnort")])]),_c('td',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.details[0].pv_wohnort)}})])]):_vm._e(),_vm._v(" "),(_vm.details[0].pv_wohnmoeglichkeit !== 'NULL')?_c('tr',[_c('td',[_c('span',{directives:[{name:"lang",rawName:"v-lang.wohnmoeglichkeit",modifiers:{"wohnmoeglichkeit":true}}]},[_vm._v("Wohnmöglichkeit")])]),_c('td',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.details[0].pv_wohnmoeglichkeit)}})])]):_vm._e(),_vm._v(" "),(_vm.details[0].pv_web !== 'NULL' && _vm.details[0].pv_web !== '')?_c('tr',[_c('td',[_c('span',{directives:[{name:"lang",rawName:"v-lang.website",modifiers:{"website":true}}]},[_vm._v("Website")])]),_c('td',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.details[0].pv_web)}})])]):_vm._e(),_vm._v(" "),(_vm.details[0].pv_ausbildung !== 'NULL' && _vm.details[0].pv_ausbildung !== '')?_c('tr',[_c('td',[_c('span',{directives:[{name:"lang",rawName:"v-lang.ausbildung",modifiers:{"ausbildung":true}}]},[_vm._v("Ausbildung")])]),_c('td',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.filterHtml(_vm.details[0].pv_ausbildung))}})])]):_vm._e()])])])]),_vm._v(" "),(_vm.hasAuftrittsart('theat') 
                        && (_vm.matchedSize === 'lg' || _vm.matchedSize === 'xl'))?_c('div',{staticClass:"card vita mb-4"},[_c('div',{staticClass:"card-header"},[_c('h4',{directives:[{name:"lang",rawName:"v-lang.theater",modifiers:{"theater":true}}],staticClass:"text-center lower-3"},[_vm._v("Theater (Auswahl)")])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('people-info',{attrs:{"infos":_vm.filterByAuftrittsart('theat')}})],1)]):_vm._e(),_vm._v(" "),(_vm.hasAuftrittsart('sonst') 
                        && (_vm.matchedSize === 'lg' || _vm.matchedSize === 'xl')
                        && _vm.showSonstOnLeftColumn())?_c('div',{staticClass:"card vita mb-4"},[_c('div',{staticClass:"card-header"},[_c('h4',{directives:[{name:"lang",rawName:"v-lang.sonstiges",modifiers:{"sonstiges":true}}],staticClass:"text-center lower-3"},[_vm._v("Sonstiges (Auswahl)")])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('people-info',{attrs:{"infos":_vm.filterByAuftrittsart('sonst')}})],1)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-lg-6"},[(_vm.hasAuftrittsart('award'))?_c('div',{staticClass:"card vita mb-4"},[_c('div',{staticClass:"card-header"},[_c('h4',{directives:[{name:"lang",rawName:"v-lang.auszeichnungen",modifiers:{"auszeichnungen":true}}],staticClass:"text-center lower-3"},[_vm._v("Auszeichnungen")])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('people-info',{attrs:{"infos":_vm.filterByAuftrittsart('award')}})],1)]):_vm._e(),_vm._v(" "),(_vm.hasAuftrittsart('film'))?_c('div',{staticClass:"card vita mb-4"},[_c('div',{staticClass:"card-header"},[_c('h4',{directives:[{name:"lang",rawName:"v-lang.filmTv",modifiers:{"filmTv":true}}],staticClass:"text-center lower-3"},[_vm._v("Film/TV (Auswahl)")])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('people-info',{attrs:{"infos":_vm.filterByAuftrittsart('film')}})],1)]):_vm._e(),_vm._v(" "),(_vm.hasAuftrittsart('theat') 
                        && (_vm.matchedSize !== 'lg' && _vm.matchedSize !== 'xl'))?_c('div',{staticClass:"card vita mb-4"},[_c('div',{staticClass:"card-header"},[_c('h4',{directives:[{name:"lang",rawName:"v-lang.theater",modifiers:{"theater":true}}],staticClass:"text-center lower-3"},[_vm._v("Theater (Auswahl)")])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('people-info',{attrs:{"infos":_vm.filterByAuftrittsart('theat')}})],1)]):_vm._e(),_vm._v(" "),(_vm.hasAuftrittsart('sonst')
                        && ((_vm.matchedSize !== 'lg' && _vm.matchedSize !== 'xl')
                         || !_vm.showSonstOnLeftColumn()))?_c('div',{staticClass:"card vita mb-4"},[_c('div',{staticClass:"card-header"},[_c('h4',{directives:[{name:"lang",rawName:"v-lang.sonstiges",modifiers:{"sonstiges":true}}],staticClass:"text-center lower-3"},[_vm._v("Sonstiges (Auswahl)")])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('people-info',{attrs:{"infos":_vm.filterByAuftrittsart('sonst')}})],1)]):_vm._e()])])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 551:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapse",staticStyle:{"background":"#3e3d40"},attrs:{"id":_vm.collapseName}},[_c('div',{staticStyle:{"padding":"20px","padding-bottom":"50px"}},[_c('button',{staticClass:"close",staticStyle:{"margin-top":"6px","margin-right":"10px"},attrs:{"type":"button","aria-label":"Close","data-toggle":"collapse","data-target":_vm.anchorCollapseName()},on:{"click":_vm.resetActor}},[_c('span',{staticStyle:{"z-index":"100","color":"white","cursor":"pointer"},attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" "),_c('h1',{staticClass:"my-1 font-bold text-center white-text mb-4",staticStyle:{"padding-left":"10px"},domProps:{"innerHTML":_vm._s(_vm.name)}}),_vm._v(" "),(_vm.details != null && _vm.details.length > 0)?_c('people-detail',{attrs:{"actor":_vm.actor,"details":_vm.details,"matchedSize":_vm.matchedSize,"medien":_vm.medien,"auftrittsarten":_vm.auftrittsarten,"auftritte":_vm.auftritte}}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 552:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pb-4"},[_c('section',{staticClass:"section team-section mt-4 px-4 wow fadeIn",attrs:{"data-wow-delay":"0.3s"}},[_c('div',{staticClass:"d-flex justify-content-around"},_vm._l((_vm.actorsPerLine.actors),function(actor,index){return _c('thumb',{key:actor.pv_id,attrs:{"collapseName":_vm.actorsPerLine.line,"numberOfActorsPerLine":_vm.numberOfActorsPerLine,"actor":actor,"isSameActorFn":_vm.isSameActorFn},nativeOn:{"click":function($event){_vm.selectActor(index)}}})}))]),_vm._v(" "),_c('actor',{attrs:{"collapseName":this.actorsPerLine.line,"actor":_vm.actor,"matchedSize":_vm.matchedSize,"isSameLineFn":_vm.isSameLineFn,"isSameActorFn":_vm.isSameActorFn}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 553:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"onmedia",rawName:"v-onmedia",value:(_vm.matchMedia),expression:"matchMedia"}],staticClass:"picture1"},[_c('div',{staticStyle:{"height":"90px"},attrs:{"id":"home"}}),_vm._v(" "),_c('div',{staticStyle:{"height":"20px"},attrs:{"id":"people"}}),_vm._v(" "),_vm._l((_vm.actorsPerLines),function(actorsPerLine){return _c('section-people-row',{key:actorsPerLine.line,attrs:{"actorsPerLine":actorsPerLine,"numberOfActorsPerLine":_vm.numberOfActorsPerLine,"matchedSize":_vm.matchedSize,"isSameLineFn":_vm.isSameLineFn,"isSameActorFn":_vm.isSameActorFn}})})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 554:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_News_vue__ = __webpack_require__(167);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44ed80c0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_News_vue__ = __webpack_require__(561);
function injectStyle (ssrContext) {
  __webpack_require__(555)
}
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_News_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44ed80c0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_News_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 555:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 556:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Facebook_vue__ = __webpack_require__(168);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f6b94a4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Facebook_vue__ = __webpack_require__(560);
function injectStyle (ssrContext) {
  __webpack_require__(557)
}
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Facebook_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f6b94a4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Facebook_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 557:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 559:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 169,
	"./af.js": 169,
	"./ar": 170,
	"./ar-dz": 171,
	"./ar-dz.js": 171,
	"./ar-kw": 172,
	"./ar-kw.js": 172,
	"./ar-ly": 173,
	"./ar-ly.js": 173,
	"./ar-ma": 174,
	"./ar-ma.js": 174,
	"./ar-sa": 175,
	"./ar-sa.js": 175,
	"./ar-tn": 176,
	"./ar-tn.js": 176,
	"./ar.js": 170,
	"./az": 177,
	"./az.js": 177,
	"./be": 178,
	"./be.js": 178,
	"./bg": 179,
	"./bg.js": 179,
	"./bm": 180,
	"./bm.js": 180,
	"./bn": 181,
	"./bn.js": 181,
	"./bo": 182,
	"./bo.js": 182,
	"./br": 183,
	"./br.js": 183,
	"./bs": 184,
	"./bs.js": 184,
	"./ca": 185,
	"./ca.js": 185,
	"./cs": 186,
	"./cs.js": 186,
	"./cv": 187,
	"./cv.js": 187,
	"./cy": 188,
	"./cy.js": 188,
	"./da": 189,
	"./da.js": 189,
	"./de": 190,
	"./de-at": 191,
	"./de-at.js": 191,
	"./de-ch": 192,
	"./de-ch.js": 192,
	"./de.js": 190,
	"./dv": 193,
	"./dv.js": 193,
	"./el": 194,
	"./el.js": 194,
	"./en-au": 195,
	"./en-au.js": 195,
	"./en-ca": 196,
	"./en-ca.js": 196,
	"./en-gb": 197,
	"./en-gb.js": 197,
	"./en-ie": 198,
	"./en-ie.js": 198,
	"./en-il": 199,
	"./en-il.js": 199,
	"./en-nz": 200,
	"./en-nz.js": 200,
	"./eo": 201,
	"./eo.js": 201,
	"./es": 202,
	"./es-do": 203,
	"./es-do.js": 203,
	"./es-us": 204,
	"./es-us.js": 204,
	"./es.js": 202,
	"./et": 205,
	"./et.js": 205,
	"./eu": 206,
	"./eu.js": 206,
	"./fa": 207,
	"./fa.js": 207,
	"./fi": 208,
	"./fi.js": 208,
	"./fo": 209,
	"./fo.js": 209,
	"./fr": 210,
	"./fr-ca": 211,
	"./fr-ca.js": 211,
	"./fr-ch": 212,
	"./fr-ch.js": 212,
	"./fr.js": 210,
	"./fy": 213,
	"./fy.js": 213,
	"./gd": 214,
	"./gd.js": 214,
	"./gl": 215,
	"./gl.js": 215,
	"./gom-latn": 216,
	"./gom-latn.js": 216,
	"./gu": 217,
	"./gu.js": 217,
	"./he": 218,
	"./he.js": 218,
	"./hi": 219,
	"./hi.js": 219,
	"./hr": 220,
	"./hr.js": 220,
	"./hu": 221,
	"./hu.js": 221,
	"./hy-am": 222,
	"./hy-am.js": 222,
	"./id": 223,
	"./id.js": 223,
	"./is": 224,
	"./is.js": 224,
	"./it": 225,
	"./it.js": 225,
	"./ja": 226,
	"./ja.js": 226,
	"./jv": 227,
	"./jv.js": 227,
	"./ka": 228,
	"./ka.js": 228,
	"./kk": 229,
	"./kk.js": 229,
	"./km": 230,
	"./km.js": 230,
	"./kn": 231,
	"./kn.js": 231,
	"./ko": 232,
	"./ko.js": 232,
	"./ky": 233,
	"./ky.js": 233,
	"./lb": 234,
	"./lb.js": 234,
	"./lo": 235,
	"./lo.js": 235,
	"./lt": 236,
	"./lt.js": 236,
	"./lv": 237,
	"./lv.js": 237,
	"./me": 238,
	"./me.js": 238,
	"./mi": 239,
	"./mi.js": 239,
	"./mk": 240,
	"./mk.js": 240,
	"./ml": 241,
	"./ml.js": 241,
	"./mr": 242,
	"./mr.js": 242,
	"./ms": 243,
	"./ms-my": 244,
	"./ms-my.js": 244,
	"./ms.js": 243,
	"./mt": 245,
	"./mt.js": 245,
	"./my": 246,
	"./my.js": 246,
	"./nb": 247,
	"./nb.js": 247,
	"./ne": 248,
	"./ne.js": 248,
	"./nl": 249,
	"./nl-be": 250,
	"./nl-be.js": 250,
	"./nl.js": 249,
	"./nn": 251,
	"./nn.js": 251,
	"./pa-in": 252,
	"./pa-in.js": 252,
	"./pl": 253,
	"./pl.js": 253,
	"./pt": 254,
	"./pt-br": 255,
	"./pt-br.js": 255,
	"./pt.js": 254,
	"./ro": 256,
	"./ro.js": 256,
	"./ru": 257,
	"./ru.js": 257,
	"./sd": 258,
	"./sd.js": 258,
	"./se": 259,
	"./se.js": 259,
	"./si": 260,
	"./si.js": 260,
	"./sk": 261,
	"./sk.js": 261,
	"./sl": 262,
	"./sl.js": 262,
	"./sq": 263,
	"./sq.js": 263,
	"./sr": 264,
	"./sr-cyrl": 265,
	"./sr-cyrl.js": 265,
	"./sr.js": 264,
	"./ss": 266,
	"./ss.js": 266,
	"./sv": 267,
	"./sv.js": 267,
	"./sw": 268,
	"./sw.js": 268,
	"./ta": 269,
	"./ta.js": 269,
	"./te": 270,
	"./te.js": 270,
	"./tet": 271,
	"./tet.js": 271,
	"./tg": 272,
	"./tg.js": 272,
	"./th": 273,
	"./th.js": 273,
	"./tl-ph": 274,
	"./tl-ph.js": 274,
	"./tlh": 275,
	"./tlh.js": 275,
	"./tr": 276,
	"./tr.js": 276,
	"./tzl": 277,
	"./tzl.js": 277,
	"./tzm": 278,
	"./tzm-latn": 279,
	"./tzm-latn.js": 279,
	"./tzm.js": 278,
	"./ug-cn": 280,
	"./ug-cn.js": 280,
	"./uk": 281,
	"./uk.js": 281,
	"./ur": 282,
	"./ur.js": 282,
	"./uz": 283,
	"./uz-latn": 284,
	"./uz-latn.js": 284,
	"./uz.js": 283,
	"./vi": 285,
	"./vi.js": 285,
	"./x-pseudo": 286,
	"./x-pseudo.js": 286,
	"./yo": 287,
	"./yo.js": 287,
	"./zh-cn": 288,
	"./zh-cn.js": 288,
	"./zh-hk": 289,
	"./zh-hk.js": 289,
	"./zh-tw": 290,
	"./zh-tw.js": 290
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 559;

/***/ }),

/***/ 560:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-6 col-sm-6 col-md-4 col-lg-3 col-xl-3 text-center mb-4"},[_c('div',{staticClass:"card facebook"},[_c('div',{staticClass:"view overlay"},[_c('img',{staticClass:"img-fluid",staticStyle:{"min-width":"100%"},attrs:{"src":_vm.feed.thumb,"alt":"sample"}}),_vm._v(" "),_c('a',{attrs:{"href":_vm.feed.link,"target":"_blank"}},[_c('div',{staticClass:"mask rgba-white-slight"})])]),_vm._v(" "),_c('a',{staticClass:"btn-floating btn-action ml-auto mr-4 lighten-3",staticStyle:{"background":"#0188c0"},attrs:{"href":_vm.feed.link,"target":"_blank"}},[_c('i',{staticClass:"fa fa-chevron-right"})]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('p',{staticClass:"font-small grey-dark-text mb-0 text-left",domProps:{"innerHTML":_vm._s(_vm.linkifiedContent)}})]),_vm._v(" "),_c('div',{staticClass:"lighten-3 text-center",staticStyle:{"background":"#0188c0"}},[_c('ul',{staticClass:"list-unstyled list-inline font-small mt-3"},[_c('li',{staticClass:"list-inline-item pr-2 white-text"},[_c('i',{staticClass:"fa fa-clock-o pr-1"}),_vm._v(_vm._s(_vm.formatDate()))])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 561:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"onmedia",rawName:"v-onmedia",value:(_vm.matchMedia),expression:"matchMedia"}],staticClass:"news"},[_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section pb-5 wow fadeIn",staticStyle:{"border-top":"1px solid white","padding-bottom":"0px!important"},attrs:{"id":"news","data-wow-delay":"0.3s"}},[_c('div',{staticStyle:{"background-color":"#0187c044","width":"100%","height":"100%"}},[_c('h1',{staticClass:"section-heading h1 pt-5 mt-4 mb-5",staticStyle:{"color":"#757575","margin-top":"0px!important","padding-top":"60px!important"}},[_vm._v("News")]),_vm._v(" "),_c('div',{staticClass:"container",staticStyle:{"max-width":"100%","padding-bottom":"50px"}},[_c('div',{staticClass:"row mx-xs-0 mx-sm-1 mx-md-3 mx-lg-5"},[_c('iframe',{attrs:{"src":"https://embedsocial.com/api/pro_hashtag/60877d22d7d9b8ff9f6c50b271c4c9e0d73d377a","width":"1200px","height":"1000px","frameborder":"0","marginheight":"0","marginwidth":"0"}})])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 562:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Agency_vue__ = __webpack_require__(291);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0577d305_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Agency_vue__ = __webpack_require__(564);
function injectStyle (ssrContext) {
  __webpack_require__(563)
}
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Agency_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0577d305_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Agency_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 563:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 564:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"agency"},[_c('section',{staticClass:"section wow fadeIn",attrs:{"id":"agency","data-wow-delay":"0.3s"}},[_c('div',{staticClass:"row text-center pt-5"},[_c('div',{staticClass:"col-md-12 mb-r px-4"},[_c('p',{directives:[{name:"lang",rawName:"v-lang.agenturText1",modifiers:{"agenturText1":true}}],staticClass:"section-description"}),_vm._v(" "),_c('p',{directives:[{name:"lang",rawName:"v-lang.agenturText2",modifiers:{"agenturText2":true}}],staticClass:"section-description"}),_vm._v(" "),_c('p',{directives:[{name:"lang",rawName:"v-lang.agenturText3",modifiers:{"agenturText3":true}}],staticClass:"section-description"}),_vm._v(" "),_c('p',{directives:[{name:"lang",rawName:"v-lang.agenturText4",modifiers:{"agenturText4":true}}],staticClass:"section-description"}),_vm._v(" "),_c('p',{staticClass:"section-description"},[_vm._v("Sylvia Heimann")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 565:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__ = __webpack_require__(292);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_899cb656_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__ = __webpack_require__(587);
function injectStyle (ssrContext) {
  __webpack_require__(566)
}
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-899cb656"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_899cb656_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 566:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 57:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  scheme: "https"
});

/***/ }),

/***/ 587:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('section',{staticClass:"section pb-5 wow fadeIn",attrs:{"id":"contact","data-wow-delay":"0.3s"}},[_c('h1',{directives:[{name:"lang",rawName:"v-lang.schreibenSieUns",modifiers:{"schreibenSieUns":true}}],staticClass:"section-heading h1 pt-5"},[_vm._v("Schreiben Sie uns!")]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-md-8 col-xl-9"},[_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"md-form",class:{ invalid : _vm.$v.name.$error }},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.name),expression:"name",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"text","id":"contact-name"},domProps:{"value":(_vm.name)},on:{"blur":[function($event){_vm.$v.name.$touch()},function($event){_vm.$forceUpdate()}],"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value.trim()}}}),_vm._v(" "),_c('label',{directives:[{name:"lang",rawName:"v-lang.ihrName",modifiers:{"ihrName":true}}],attrs:{"for":"contact-name"}},[_vm._v("Ihr Name")]),_vm._v(" "),(!_vm.$v.name.required && _vm.$v.name.$error)?_c('p',{staticClass:"invalid-text-style"},[_vm._v("Feld muss gefüllt sein")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"md-form",class:{ invalid : _vm.$v.email.$error }},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.email),expression:"email",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"email","id":"contact-email"},domProps:{"value":(_vm.email)},on:{"blur":[function($event){_vm.$v.email.$touch()},function($event){_vm.$forceUpdate()}],"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value.trim()}}}),_vm._v(" "),_c('label',{directives:[{name:"lang",rawName:"v-lang.ihreEmail",modifiers:{"ihreEmail":true}}],attrs:{"for":"contact-email"}},[_vm._v("Ihre Email")]),_vm._v(" "),(!_vm.$v.email.email && _vm.$v.email.$error)?_c('p',{staticClass:"invalid-text-style"},[_vm._v("Ungültiges Format")]):_vm._e(),_vm._v(" "),(!_vm.$v.email.required && _vm.$v.email.$error)?_c('p',{staticClass:"invalid-text-style"},[_vm._v("Feld muss gefüllt sein")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"md-form",class:{ invalid : _vm.$v.betreff.$error }},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.betreff),expression:"betreff",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"text","id":"contact-subject"},domProps:{"value":(_vm.betreff)},on:{"blur":[function($event){_vm.$v.betreff.$touch()},function($event){_vm.$forceUpdate()}],"input":function($event){if($event.target.composing){ return; }_vm.betreff=$event.target.value.trim()}}}),_vm._v(" "),_c('label',{directives:[{name:"lang",rawName:"v-lang.betreff",modifiers:{"betreff":true}}],attrs:{"for":"contact-subject"}},[_vm._v("Betreff")]),_vm._v(" "),(!_vm.$v.betreff.required && _vm.$v.betreff.$error)?_c('p',{staticClass:"invalid-text-style"},[_vm._v("Feld muss gefüllt sein")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"md-form",class:{ invalid : _vm.$v.nachricht.$error }},[_c('textarea',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.nachricht),expression:"nachricht",modifiers:{"trim":true}}],staticClass:"md-textarea",attrs:{"type":"text","id":"contact-message"},domProps:{"value":(_vm.nachricht)},on:{"blur":[function($event){_vm.$v.nachricht.$touch()},function($event){_vm.$forceUpdate()}],"input":function($event){if($event.target.composing){ return; }_vm.nachricht=$event.target.value.trim()}}}),_vm._v(" "),_c('label',{directives:[{name:"lang",rawName:"v-lang.ihreNachricht",modifiers:{"ihreNachricht":true}}],attrs:{"for":"contact-message"}},[_vm._v("Ihre Nachricht")]),_vm._v(" "),(!_vm.$v.nachricht.required && _vm.$v.nachricht.$error)?_c('p',{staticClass:"invalid-text-style",staticStyle:{"margin-top":"-5px"}},[_vm._v("Feld muss gefüllt sein")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"md-form"},[_c('div',{staticClass:"form-group checkbox-rounded-heimanns-red"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.isAgreed),expression:"isAgreed"}],staticClass:"filled-in",attrs:{"type":"checkbox","id":"isAgreed"},domProps:{"checked":Array.isArray(_vm.isAgreed)?_vm._i(_vm.isAgreed,null)>-1:(_vm.isAgreed)},on:{"change":function($event){var $$a=_vm.isAgreed,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.isAgreed=$$a.concat([$$v]))}else{$$i>-1&&(_vm.isAgreed=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.isAgreed=$$c}}}}),_vm._v(" "),_c('label',{attrs:{"for":"isAgreed"}},[_vm._v("Ich bin einverstanden.")])])])])])]),_vm._v(" "),_c('div',{staticClass:"center-on-small-only"},[(!_vm.isSending)?_c('button',{directives:[{name:"lang",rawName:"v-lang.absenden",modifiers:{"absenden":true}}],staticClass:"btn btn-primary btn-rounded",attrs:{"disabled":_vm.$v.$invalid || !_vm.isAgreed},on:{"click":function($event){$event.preventDefault();_vm.sendMail($event)}}},[_vm._v("Absenden")]):_vm._e(),_vm._v(" "),(_vm.isSending)?_c('div',{staticClass:"preloader-wrapper small active ml-5"},[_vm._m(2)]):_vm._e()])])]),_vm._v(" "),(_vm.isSubmitted)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col mt-3"},[_c('hr'),_vm._v(" "),_c('div',{staticClass:"panel panel-default"},[_c('div',{staticClass:"panel-heading text-center"},[_c('h4',{directives:[{name:"lang",rawName:"v-lang.nachrichtVersendet",modifiers:{"nachrichtVersendet":true}}]},[_vm._v("Vielen Dank. Die Nachricht wurde versendet.")])])])])]):_vm._e(),_vm._v(" "),(_vm.wasResponseError)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col mt-3"},[_c('hr'),_vm._v(" "),_c('div',{staticClass:"panel panel-default"},[_c('div',{staticClass:"panel-heading text-center"},[_c('h4',{directives:[{name:"lang",rawName:"v-lang.fehlerNochmal",modifiers:{"fehlerNochmal":true}}],staticClass:"red-text"},[_vm._v("Ein Fehler ist aufgetreten! Bitte versuchen Sie es später erneut.")])])])])]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-4 col-xl-3"},[_c('h4',{staticClass:"text-center",staticStyle:{"margin-top":"13px","margin-bottom":"22px"}},[_vm._v("Heimann.s Agentur")]),_vm._v(" "),_c('ul',{staticClass:"contact-icons"},[_c('li',{staticClass:"mb-1"},[_c('i',{staticClass:"fa fa-map-marker fa-2x"}),_vm._v(" "),_c('p',[_vm._v("c/o RIWAS 12, "),_c('br'),_vm._v("Richard-Wagner-Str. 12, "),_c('br'),_vm._v("50674 Köln")])]),_vm._v(" "),_c('li',{staticClass:"mb-1"},[_c('a',{staticStyle:{"color":"#757575"},attrs:{"href":"tel:+492218469120"}},[_c('i',{staticClass:"fa fa-phone fa-2x"}),_vm._v(" "),_c('p',[_vm._v("+ 49 (0) 221 - 846 91 20")])])]),_vm._v(" "),_c('li',{staticClass:"mb-3"},[_c('a',{staticStyle:{"color":"#757575"},attrs:{"href":"mailto:info@heimanns-agentur.de"}},[_c('i',{staticClass:"fa fa-envelope fa-2x"}),_vm._v(" "),_c('p',[_vm._v("info@heimanns-agentur.de")])])]),_vm._v(" "),_c('li',{staticClass:"mt-4 mb-3"},[_c('a',{staticClass:"icons-sm fb-ic",attrs:{"target":"_blank","href":"https://www.facebook.com/pages/Heimanns-Agentur/174592245925723"}},[_c('i',{staticClass:"fa fa-facebook"})]),_vm._v(" "),_c('a',{staticClass:"icons-sm fb-ic",attrs:{"target":"_blank","href":"https://www.instagram.com/heimann.s_agentur/"}},[_c('i',{staticClass:"fa fa-instagram"})])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticStyle:{"font-size":"0.9rem"}},[_vm._v("\n                                       Mit Nutzung des Kontaktformulars werden die angegebenen Daten vorübergehend \n                                       zwecks Kontaktaufnahme von Heimann.s Agentur verarbeitet. \n                                       Der Nutzer erklärt sich ausdrücklich mit dieser Datenverwendung einverstanden. \n                                       Weiterhin stimmt der Nutzer zu, dass die Daten (zur Zeit) unverschlüsselt übertragen werden.\n                                       Nähere Informationen entnehmen Sie bitte unserer \n                                       "),_c('a',{attrs:{"href":"#","data-toggle":"modal","data-target":".bd-data-protection-modal-lg"}},[_c('span',{staticStyle:{"color":"#0188c0"}},[_vm._v("Datenschutzerklärung")])]),_vm._v(". \n                                   ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner-layer spinner-blue-only"},[_c('div',{staticClass:"circle-clipper left"},[_c('div',{staticClass:"circle"})]),_c('div',{staticClass:"gap-patch"},[_c('div',{staticClass:"circle"})]),_c('div',{staticClass:"circle-clipper right"},[_c('div',{staticClass:"circle"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 588:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Imprint_vue__ = __webpack_require__(293);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06a11d48_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Imprint_vue__ = __webpack_require__(590);
function injectStyle (ssrContext) {
  __webpack_require__(589)
}
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Imprint_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06a11d48_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Imprint_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 589:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 590:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade bd-imprint-modal-lg",attrs:{"tabindex":"-1","role":"dialog","aria-labelledby":"myLargeModalLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h4',{staticClass:"modal-title",attrs:{"id":"myModalLabel"}},[_vm._v("Impressum")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('h5',[_vm._v("Heimann.s Agentur")]),_vm._v(" "),_c('p',[_vm._v("Sylvia Heimann"),_c('br'),_vm._v("\n                c/o RIWAS 12"),_c('br'),_vm._v("\n                Richard-Wagner-Str. 12"),_c('br'),_vm._v("\n                50674 Köln")]),_vm._v(" "),_c('p',[_vm._v("\n                Email:info(at)heimanns-agentur.de"),_c('br'),_vm._v("\n                Telefon: 0221 / 846 91-20 "),_c('br'),_vm._v("\n                Telefax: 0221 / 846 91-19")]),_vm._v(" "),_c('p',[_vm._v("Finanzamt Köln-Altstadt"),_c('br'),_vm._v("\n                Umsatzsteuer-ID-Nr. DE257476682")]),_vm._v(" "),_c('p',[_vm._v("Inhaltlich Verantwortliche gemäß § 55 RStV: Sylvia Heimann")]),_vm._v(" "),_c('p',[_vm._v("\n                    Diese Seiten sind Teil von Heimann.s Agentur. Verantwortlich für Inhalt und Darstellung ist:\n                ")]),_vm._v(" "),_c('p',[_vm._v("Sylvia Heimann"),_c('br'),_vm._v("\n                c/o RIWAS 12"),_c('br'),_vm._v("\n                Richard-Wagner-Str. 12"),_c('br'),_vm._v("\n                50674 Köln")]),_vm._v(" "),_c('p',[_vm._v("\n                Email:info(at)heimanns-agentur.de"),_c('br'),_vm._v("\n                Telefon: 0221 / 846 91-20 "),_c('br'),_vm._v("\n                    Telefax: 0221 / 846 91-19")]),_vm._v(" "),_c('h5',[_vm._v("Konzept und Ideen")]),_vm._v(" "),_c('p',[_vm._v("Jochen Alexander Wigand, Sylvia Heimann, Kai Müller")]),_vm._v(" "),_c('h5',[_vm._v("Programmierung")]),_vm._v(" "),_c('p',[_vm._v("Kai Müller: "),_c('a',{staticStyle:{"color":"#0188c0"},attrs:{"href":"http://www.kai-mueller.info"}},[_vm._v("http://www.kai-mueller.info")])]),_vm._v(" "),_c('h5',[_vm._v("Haftungsausschluß")]),_vm._v(" "),_c('p',[_vm._v("\n                    1. Inhalt des Onlineangebotes"),_c('br'),_vm._v("\n                    Heimann.s Agentur (Autor) und die Informationszubringer sind stets bemüht, qualitativ hochwertige Informationen zur Verfügung zu stellen. Trotzdem übernimmt Autor keinerlei Gewähr für die Aktualität, Korrektheit, Vollständigkeit oder Qualität der bereitgestellten Informationen. Haftungsansprüche gegen Autoren, die sich auf Schäden materieller oder ideeller Art beziehen, welche durch die Nutzung oder Nichtnutzung der dargebotenen Informationen bzw. durch die Nutzung fehlerhafter und unvollständiger Informationen verursacht wurden sind grundsätzlich ausgeschlossen, sofern seitens Autor kein nachweislich vorsätzliches oder grob fahrlässiges Verschulden vorliegt. Alle Angebote sind frei bleibend und unverbindlich. Der Autor behält es sich ausdrücklich vor, Teile der Seiten oder das gesamte Angebot ohne gesonderte Ankündigung zu verändern, zu ergänzen, zu löschen oder die Veröffentlichung zeitweise oder endgültig einzustellen.\n                ")]),_vm._v(" "),_c('p',[_vm._v("\n                    2. Verweise und Links"),_c('br'),_vm._v("\n                    Sofern auf Verweisziele (\"Links\") direkt oder indirekt verwiesen wird, die außerhalb des Verantwortungsbereiches von Autor liegen, entstehen daraus für Autor keinerlei Haftungsansprüche. Für die Inhalte und insbesondere für Schäden, die aus der Nutzung oder Nichtnutzung solcherart dargebotener Informationen entstehen, haftet allein der Anbieter dieser Seiten, nicht derjenige, der über Links auf die jeweilige Veröffentlichung lediglich verweist. Diese Einschränkung gilt gleichermaßen auch für Fremdeinträge in von Autor eingerichteten Gästebüchern, Diskussionsforen und Mailinglisten.\n                ")]),_vm._v(" "),_c('p',[_vm._v("\n                    3. Urheberrecht"),_c('br'),_vm._v("\n                    Der Autor ist bestrebt, in allen Publikationen die Urheberrechte der verwendeten Grafiken, Tondokumente, Videosequenzen und Texte zu beachten, von ihm selbst erstellte Grafiken, Tondokumente, Videosequenzen und Texte zu nutzen oder auf lizenzfreie Grafiken, Tondokumente, Videosequenzen und Texte zurückzugreifen. Alle innerhalb des Internetangebotes genannten und ggf. durch Dritte geschützten Marken- und Warenzeichen unterliegen uneingeschränkt den Bestimmungen des jeweils gültigen Kennzeichenrechts und den Besitzrechten der jeweiligen eingetragenen Eigentümer. Allein aufgrund der bloßen Nennung ist nicht der Schluss zu ziehen, dass Markenzeichen nicht durch Rechte Dritter geschützt sind! Das Copyright für veröffentlichte, vom Autor selbst erstellte Objekte bleibt allein beim Autor der Seiten. Eine Vervielfältigung oder Verwendung solcher Grafiken, Tondokumente, Videosequenzen und Texte in anderen elektronischen oder gedruckten Publikationen ist ohne ausdrückliche Zustimmung des Autors nicht gestattet.\n                ")]),_vm._v(" "),_c('p',[_vm._v("\n                    4. Rechtswirksamkeit dieses Haftungsausschlusses"),_c('br'),_vm._v("\n                    Dieser Haftungsausschluss ist Teil des Internetangebots www.heimanns-agentur.de. Sofern Teile oder einzelne Formulierungen dieses Textes der geltenden Rechtslage nicht, nicht mehr oder nicht vollständig entsprechen sollten, bleiben die übrigen Teile des Dokumentes in ihrem Inhalt und ihrer Gültigkeit davon unberührt.\n                ")]),_vm._v(" "),_c('p',[_vm._v("© Heimann.s Agentur 2026\n                ")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 591:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__ = __webpack_require__(294);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_691d2663_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__(593);
function injectStyle (ssrContext) {
  __webpack_require__(592)
}
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_691d2663_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 592:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 593:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"page-footer center-on-small-only"},[_c('div',{staticClass:"container mb-0 pb-0"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('p',{directives:[{name:"lang",rawName:"v-lang.daff",modifiers:{"daff":true}}],staticClass:"text-center mb-0"})])])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-4 mb-3 text-center"},[_c('a',{attrs:{"target":"_blank","href":"https://daff.tv/"}},[_c('img',{staticClass:"dafflogo",attrs:{"src":__webpack_require__(594),"alt":"Logo DAFF"}})]),_vm._v("\n         \n        "),_c('a',{attrs:{"target":"_blank","href":"https://verband-der-agenturen.de"}},[_c('img',{staticClass:"vdalogo",attrs:{"src":__webpack_require__(595),"alt":"Logo VdA"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer-copyright mt-0 pt-0"},[_c('div',{staticClass:"container-fluid"},[_vm._v("\n            © 2026 Copyright: Heimann.s Agentur  \n            "),_c('a',{attrs:{"href":"#","data-toggle":"modal","data-target":".bd-imprint-modal-lg"}},[_vm._v(" Impressum ")]),_vm._v(" \n            "),_c('a',{attrs:{"href":"#","data-toggle":"modal","data-target":".bd-data-protection-modal-lg"}},[_vm._v(" Datenschutzerklärung ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 594:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 595:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/VdA_Logo_III.08af621.jpg";

/***/ }),

/***/ 596:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Parallax_vue__ = __webpack_require__(295);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_587c16c8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Parallax_vue__ = __webpack_require__(598);
function injectStyle (ssrContext) {
  __webpack_require__(597)
}
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-587c16c8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Parallax_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_587c16c8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Parallax_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 597:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 598:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 text-center mb-3"},[_c('h1',{staticClass:"font-bold light-blue-text my-3"},[_vm._v("Lorem ipsum dolor sit amet, consectetur quis elit.")]),_vm._v(" "),_c('p',{attrs:{"align":"justify"}},[_vm._v("Lorem ipsum dolor sit amet, consectetur quis elit. Perspiciatis commodi porro, cumque provident rem corporis odit, ut quas dolores maxime nesciunt possimus quis, soluta velit debitis amet, veritatis cupiditate reprehenderit.Lorem ipsum dolor sit amet, consectetur quis elit. Perspiciatis commodi porro, cumque provident rem corporis odit, ut quas dolores maxime nesciunt possimus quis, soluta velit debitis amet, veritatis cupiditate reprehenderit.Lorem ipsum dolor sit amet, consectetur quis elit. Perspiciatis commodi porro, cumque provident rem corporis odit, ut quas dolores maxime nesciunt possimus quis, soluta velit debitis amet, veritatis cupiditate reprehenderit.Lorem ipsum dolor sit amet, consectetur quis elit. Perspiciatis commodi porro, cumque provident rem corporis odit, ut quas dolores maxime nesciunt possimus quis, soluta velit debitis amet, veritatis cupiditate reprehenderit.Lorem ipsum dolor sit amet, consectetur quis elit. Perspiciatis commodi porro, cumque provident rem corporis odit, ut quas dolores maxime nesciunt possimus quis, soluta velit debitis amet, veritatis cupiditate reprehenderit.Lorem ipsum dolor sit amet, consectetur quis elit. Perspiciatis commodi porro, cumque provident rem corporis odit, ut quas dolores maxime nesciunt possimus quis, soluta velit debitis amet, veritatis cupiditate reprehenderit.Lorem ipsum dolor sit amet, consectetur quis elit. Perspiciatis commodi porro, cumque provident rem corporis odit, ut quas dolores maxime nesciunt possimus quis, soluta velit debitis amet, veritatis cupiditate reprehenderit.Lorem ipsum dolor sit amet, consectetur quis elit. Perspiciatis commodi porro, cumque provident rem corporis odit, ut quas dolores maxime nesciunt possimus quis, soluta velit debitis amet, veritatis cupiditate reprehenderit.")])])])]),_vm._v(" "),_c('div',{staticClass:"view intro hm-white-light jarallax",attrs:{"data-jarallax-video":"https://vimeo.com/groups/freehd/videos/153749651"}},[_c('div',{staticClass:"full-bg-img"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"d-flex align-items-center d-flex justify-content-center",staticStyle:{"height":"700px"}},[_c('div',{staticClass:"row mt-5"},[_c('div',{staticClass:"col-md-12 wow fadeIn mb-3"},[_c('div',{staticClass:"intro-info-content text-center"},[_c('h1',{staticClass:"display-1 mb-2 wow fadeInDown",attrs:{"data-wow-delay":"0.3s"}},[_vm._v("ANNA'S "),_c('a',{staticClass:"white-text font-bold"},[_vm._v("BLOG")])]),_vm._v(" "),_c('h5',{staticClass:"font-up mb-3 mt-1 font-bold wow fadeIn",attrs:{"data-wow-delay":"0.4s"}},[_vm._v("Interior designer & Nature lover")]),_vm._v(" "),_c('a',{staticClass:"btn btn-elegant btn-lg wow fadeIn",attrs:{"data-wow-delay":"0.4s"}},[_vm._v("portfolio")]),_vm._v(" "),_c('a',{staticClass:"btn btn-outline-white btn-lg wow fadeIn",attrs:{"data-wow-delay":"0.4s"}},[_vm._v("About me")])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 text-center my-3"},[_c('h1',{staticClass:"font-bold grey-text mb-3"},[_vm._v("Lorem ipsum dolor sit amet, consectetur quis elit.")]),_vm._v(" "),_c('p',{attrs:{"align":"justify"}},[_vm._v("Lorem ipsum dolor sit amet, consectetur quis elit. Perspiciatis commodi porro, cumque provident rem corporis odit, ut quas dolores maxime nesciunt possimus quis, soluta velit debitis amet, veritatis cupiditate reprehenderit.Lorem ipsum dolor sit amet, consectetur quis elit. Perspiciatis commodi porro, cumque provident rem corporis odit, ut quas dolores maxime nesciunt possimus quis, soluta velit debitis amet, veritatis cupiditate reprehenderit.Lorem ipsum dolor sit amet, consectetur quis elit. Perspiciatis commodi porro, cumque provident rem corporis odit, ut quas dolores maxime nesciunt possimus quis, soluta velit debitis amet, veritatis cupiditate reprehenderit.Lorem ipsum dolor sit amet, consectetur quis elit. Perspiciatis commodi porro, cumque provident rem corporis odit, ut quas dolores maxime nesciunt possimus quis, soluta velit debitis amet, veritatis cupiditate reprehenderit.Lorem ipsum dolor sit amet, consectetur quis elit. Perspiciatis commodi porro, cumque provident rem corporis odit, ut quas dolores maxime nesciunt possimus quis, soluta velit debitis amet, veritatis cupiditate reprehenderit.Lorem ipsum dolor sit amet, consectetur quis elit. Perspiciatis commodi porro, cumque provident rem corporis odit, ut quas dolores maxime nesciunt possimus quis, soluta velit debitis amet, veritatis cupiditate reprehenderit.Lorem ipsum dolor sit amet, consectetur quis elit. Perspiciatis commodi porro, cumque provident rem corporis odit, ut quas dolores maxime nesciunt possimus quis, soluta velit debitis amet, veritatis cupiditate reprehenderit.Lorem ipsum dolor sit amet, consectetur quis elit. Perspiciatis commodi porro, cumque provident rem corporis odit, ut quas dolores maxime nesciunt possimus quis, soluta velit debitis amet, veritatis cupiditate reprehenderit.")])])])]),_vm._v(" "),_c('div',{staticClass:"view intro hm-pink-slight jarallax",staticStyle:{"background-image":"url(https://mdbootstrap.com/img/Photos/Others/food2.jpg)"},attrs:{"data-jarallax":"{\"speed\": 0.2}"}},[_c('div',{staticClass:"full-bg-img"})]),_vm._v(" "),_c('div',{staticClass:"view intro hm-purple-slight jarallax",staticStyle:{"background-image":"url(https://mdbootstrap.com/img/Photos/Others/background.jpg)"},attrs:{"data-jarallax":"{\"speed\": 0.2}"}},[_c('div',{staticClass:"full-bg-img"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"d-flex align-items-center d-flex justify-content-center",staticStyle:{"height":"700px"}},[_c('div',{staticClass:"row mt-5"},[_c('div',{staticClass:"col-md-12 wow fadeIn mb-3"},[_c('div',{staticClass:"intro-info-content text-center"},[_c('h1',{staticClass:"display-1 white-text mb-2 wow fadeInDown",attrs:{"data-wow-delay":"0.3s"}},[_vm._v("Welcome on my page!")]),_vm._v(" "),_c('h4',{staticClass:"mb-3 mt-1 white-text font-bold wow fadeIn",attrs:{"data-wow-delay":"0.4s"}},[_vm._v("Lorem ipsum dolor sit amet")]),_vm._v(" "),_c('a',{staticClass:"btn btn-pink wow fadeIn",attrs:{"data-wow-delay":"0.4s"}},[_vm._v("Read more")])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 text-center my-3"},[_c('h1',{staticClass:"font-bold pink-text mb-3"},[_vm._v("Lorem ipsum dolor sit amet, consectetur quis elit.")]),_vm._v(" "),_c('p',{attrs:{"align":"justify"}},[_vm._v("Lorem ipsum dolor sit amet, consectetur quis elit. Perspiciatis commodi porro, cumque provident rem corporis odit, ut quas dolores maxime nesciunt possimus quis, soluta velit debitis amet, veritatis cupiditate reprehenderit.Lorem ipsum dolor sit amet, consectetur quis elit. Perspiciatis commodi porro, cumque provident rem corporis odit, ut quas dolores maxime nesciunt possimus quis, soluta velit debitis amet, veritatis cupiditate reprehenderit.Lorem ipsum dolor sit amet, consectetur quis elit. Perspiciatis commodi porro, cumque provident rem corporis odit, ut quas dolores maxime nesciunt possimus quis, soluta velit debitis amet, veritatis cupiditate reprehenderit.Lorem ipsum dolor sit amet, consectetur quis elit. Perspiciatis commodi porro, cumque provident rem corporis odit, ut quas dolores maxime nesciunt possimus quis, soluta velit debitis amet, veritatis cupiditate reprehenderit.Lorem ipsum dolor sit amet, consectetur quis elit. Perspiciatis commodi porro, cumque provident rem corporis odit, ut quas dolores maxime nesciunt possimus quis, soluta velit debitis amet, veritatis cupiditate reprehenderit.Lorem ipsum dolor sit amet, consectetur quis elit. Perspiciatis commodi porro, cumque provident rem corporis odit, ut quas dolores maxime nesciunt possimus quis, soluta velit debitis amet, veritatis cupiditate reprehenderit.Lorem ipsum dolor sit amet, consectetur quis elit. Perspiciatis commodi porro, cumque provident rem corporis odit, ut quas dolores maxime nesciunt possimus quis, soluta velit debitis amet, veritatis cupiditate reprehenderit.Lorem ipsum dolor sit amet, consectetur quis elit. Perspiciatis commodi porro, cumque provident rem corporis odit, ut quas dolores maxime nesciunt possimus quis, soluta velit debitis amet, veritatis cupiditate reprehenderit.")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 599:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DataProtection_vue__ = __webpack_require__(296);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8d4ec16c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DataProtection_vue__ = __webpack_require__(601);
function injectStyle (ssrContext) {
  __webpack_require__(600)
}
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DataProtection_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8d4ec16c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DataProtection_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 600:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 601:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade bd-data-protection-modal-lg",attrs:{"tabindex":"-1","role":"dialog","aria-labelledby":"myLargeModalLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h4',{staticClass:"modal-title",attrs:{"id":"myModalLabel"}},[_vm._v("Datenschutzerklärung")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('h4',[_vm._v("Datenschutz")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("\n                        Als Betreiber dieser Seiten nehme ich den Schutz Ihrer persönlichen Daten sehr ernst. Ich behandle Ihre personenbezogenen Daten vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung. \n\t\t\t\t\t\t"),_c('br'),_c('br'),_vm._v("\n                        Die Nutzung meiner Website ist in der Regel ohne Angabe personenbezogener Daten möglich. Soweit auf meinen Seiten personenbezogene Daten (beispielsweise Name, Anschrift oder E-Mail-Adressen) erhoben werden, erfolgt dies, soweit möglich, stets auf freiwilliger Basis. Diese Daten werden ohne Ihre ausdrückliche Zustimmung nicht an Dritte weitergegeben. \n                        "),_c('br'),_c('br'),_vm._v("\n                        Ich weise darauf hin, dass die Datenübertragung im Internet (z.B. bei der Kommunikation per E-Mail) Sicherheitslücken aufweisen kann. Ein lückenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht möglich. \n                    ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h5',[_vm._v("Hinweis zur verantwortlichen Stelle")]),_vm._v(" "),_c('p',[_vm._v("    Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist: siehe unter Impressum"),_c('br'),_vm._v("\n                            Telefon: siehe unter Impressum"),_c('br'),_vm._v("\n                            E-Mail: siehe unter Impressum\n\n                    "),_c('br'),_c('br'),_vm._v("\n                        Haben Sie Fragen zur Erhebung, Verarbeitung oder Nutzung Ihrer personenbezogenen Daten oder wünschen Sie eine Auskunft oder die Berichtigung, Löschung oder Sperrung Ihrer Daten, wenden Sie sich bitte an:\n                    ")]),_vm._v(" "),_c('p',[_vm._v("Sylvia Heimann"),_c('br'),_vm._v("\n                    c/o RIWAS 12"),_c('br'),_vm._v("\n                    Richard-Wagner-Str. 12"),_c('br'),_vm._v("\n                    50674 Köln")]),_vm._v(" "),_c('p',[_vm._v("\n                    Email:info(at)heimanns-agentur.de"),_c('br'),_vm._v("\n                    Telefon: 0221 / 846 91-20 "),_c('br'),_vm._v("\n                        Telefax: 0221 / 846 91-19\n                    ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h5',[_vm._v("Widerruf Ihrer Einwilligung zur Datenverarbeitung")]),_vm._v(" "),_c('p',[_vm._v("\n                       Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen Einwilligung möglich. Sie können eine bereits erteilte Einwilligung jederzeit widerrufen. Dazu reicht eine formlose Mitteilung per E-Mail an mich. Die Rechtmäßigkeit der bis zum Widerruf erfolgten Datenverarbeitung bleibt vom Widerruf unberührt. \n                    ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h5',[_vm._v("Beschwerderecht bei der zuständigen Aufsichtsbehörde")]),_vm._v(" "),_c('p',[_vm._v("\n                        Im Falle datenschutzrechtlicher Verstöße steht dem Betroffenen ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu. Zuständige Aufsichtsbehörde in datenschutzrechtlichen Fragen ist der Landesdatenschutzbeauftragte des Bundeslandes, in dem unser Unternehmen seinen Sitz hat. Eine Liste der Datenschutzbeauftragten sowie deren Kontaktdaten können folgendem Link entnommen werden: "),_c('a',{attrs:{"href":"https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html"}},[_vm._v("Liste der Datenschutzbeauftragten")]),_vm._v(".\n                    ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h5',[_vm._v("Recht auf Datenübertragbarkeit")]),_vm._v(" "),_c('p',[_vm._v("Sie haben das Recht, Daten, die ich auf Grundlage Ihrer Einwilligung oder in Erfüllung eines Vertrags automatisiert verarbeite, an sich oder an einen Dritten in einem gängigen, maschinenlesbaren Format aushändigen zu lassen. Sofern Sie die direkte Übertragung der Daten an einen anderen Verantwortlichen verlangen, erfolgt dies nur, soweit es technisch machbar ist.\n                    ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h5',[_vm._v("Recht auf Auskunft, Sperrung, Löschung")]),_vm._v(" "),_c('p',[_vm._v("Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen jederzeit das Recht auf unentgeltliche Auskunft über Ihre gespeicherten personenbezogenen Daten, deren Herkunft und Empfänger und den Zweck der Datenverarbeitung und ggfs. ein Recht auf Berichtigung, Sperrung oder Löschung dieser Daten. Hierzu sowie zu weiteren Fragen zum Thema personenbezogene Daten können Sie sich jederzeit unter der im Impressum bzw. der oben angegebenen Adresse an mich wenden.\n                    ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h4',[_vm._v("Datenerfassung auf dieser Website")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h5',[_vm._v("Cookies")]),_vm._v(" "),_c('p',[_vm._v("Zur Zeit werden keine Cookies verwendet.")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h5',[_vm._v("Server-Log-Files")]),_vm._v(" "),_c('p',[_vm._v("Der Provider der Seiten erhebt und speichert automatisch Informationen in so genannten Server-Log Files, die Ihr Browser automatisch an uns übermittelt. Dies sind: ")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Browsertyp und Browserversion")]),_vm._v(" "),_c('li',[_vm._v("Verwendetes Betriebssystem")]),_vm._v(" "),_c('li',[_vm._v("Referrer URL")]),_vm._v(" "),_c('li',[_vm._v("Hostname des zugreifenden Rechners")]),_vm._v(" "),_c('li',[_vm._v("Uhrzeit der Serveranfrage")]),_vm._v(" "),_c('li',[_vm._v("IP-Adresse")])]),_vm._v(" "),_c('p',[_vm._v("Diese Daten sind nicht bestimmten Personen zuordenbar. Eine Zusammenführung dieser Daten mit anderen Datenquellen wird nicht vorgenommen. Ich behalte mir vor, diese Daten nachträglich zu prüfen, wenn mir konkrete Anhaltspunkte für eine rechtswidrige Nutzung bekannt werden.")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h5',[_vm._v("Kontaktformular")]),_vm._v(" "),_c('p',[_vm._v("Wenn Sie mir per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei mir gespeichert. Diese Daten gebe ich nicht ohne Ihre Einwilligung weiter.")]),_vm._v(" "),_c('p',[_vm._v("Die Verarbeitung der in das Kontaktformular eingegebenen Daten erfolgt somit ausschließlich auf Grundlage Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO). Sie können diese Einwilligung jederzeit widerrufen. Dazu reicht eine formlose Mitteilung per E-Mail an mich. Die Rechtmäßigkeit der bis zum Widerruf erfolgten Datenverarbeitungsvorgänge bleibt vom Widerruf unberührt.")]),_vm._v(" "),_c('p',[_vm._v("Die von Ihnen im Kontaktformular eingegebenen Daten verbleiben bei mir, bis Sie mich zur Löschung auffordern, Ihre Einwilligung zur Speicherung widerrufen oder der Zweck für die Datenspeicherung entfällt (z.B. nach abgeschlossener Bearbeitung Ihrer Anfrage). Zwingende gesetzliche Bestimmungen – insbesondere Aufbewahrungsfristen – bleiben unberührt.")]),_vm._v(" "),_c('p',[_vm._v("Zur Zeit ist es noch nicht möglich, die Daten verschlüsselt zu übertragen. Bei Nutzung des Kontaktformular erklären Sie sich ausdrücklich mit der unverschlüsselten Datenübertragung einverstanden.\n                        "),_c('br'),_c('br'),_vm._v("\n                        Ich weise darauf hin, dass die Datenübertragung im Internet Sicherheitslücken aufweisen kann. Ein lückenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht möglich. \n                    ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h4',[_vm._v("Analysetools")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("Ich verwende auf dieser Seite keine Analysetools (wie z.B. Google Analytics, eTracker o.ä.)\n                    ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h4',[_vm._v("Plugins und Tools")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h5',[_vm._v("Google Web Fonts")]),_vm._v(" "),_c('p',[_vm._v("Diese Seite nutzt zur einheitlichen Darstellung von Schriftarten so genannte Web Fonts, die von Google bereitgestellt werden. Beim Aufruf einer Seite lädt Ihr Browser die benötigten Web Fonts in ihren Browsercache, um Texte und Schriftarten korrekt anzuzeigen.\n                    ")]),_vm._v(" "),_c('p',[_vm._v("Zu diesem Zweck muss der von Ihnen verwendete Browser Verbindung zu den Servern von Google aufnehmen. Hierdurch erlangt Google Kenntnis darüber, dass über Ihre IP-Adresse unsere Website aufgerufen wurde. Die Nutzung von Google Web Fonts erfolgt im Interesse einer einheitlichen und ansprechenden Darstellung unserer Online-Angebote. Dies stellt ein berechtigtes Interesse im Sinne von Art. 6 Abs. 1 lit. f DSGVO dar.\n                    ")]),_vm._v(" "),_c('p',[_vm._v("Wenn Ihr Browser Web Fonts nicht unterstützt, wird eine Standardschrift von Ihrem Computer genutzt.\n                    ")]),_vm._v(" "),_c('p',[_vm._v("Weitere Informationen zu Google Web Fonts finden Sie unter "),_c('a',{attrs:{"href":"https://developers.google.com/fonts/faq"}},[_vm._v("https://developers.google.com/fonts/faq")]),_vm._v(" und in der Datenschutzerklärung von Google: "),_c('a',{attrs:{"href":"https://www.google.com/policies/privacy/"}},[_vm._v("https://www.google.com/policies/privacy/")]),_vm._v(".\n                    ")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 602:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"onmedia",rawName:"v-onmedia",value:(_vm.matchMedia),expression:"matchMedia"}],attrs:{"id":"app"}},[_c('header',[_c('nav',{staticClass:"navbar navbar-expand-lg navbar-dark fixed-top scrolling-navbar"},[_c('div',{staticClass:"container navbar-width"},[_c('a',{directives:[{name:"smooth-scroll",rawName:"v-smooth-scroll",value:({ duration: 3000, offset: -50 }),expression:"{ duration: 3000, offset: -50 }"}],staticClass:"navbar-brand",attrs:{"href":"#home"}},[_c('img',{staticClass:"logo show-at-top",attrs:{"src":__webpack_require__(603),"alt":"Logo"}}),_vm._v(" "),_c('img',{staticClass:"logo show-at-scroll",attrs:{"src":__webpack_require__(604),"alt":"Logo"}}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("(current)")])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse",attrs:{"id":"navbarSupportedContent-7"}},[_c('ul',{staticClass:"navbar-nav mr-auto",staticStyle:{"font-size":"1.1rem","padding-top":"10px"}},[_c('li',{staticClass:"nav-item"},[_c('a',{directives:[{name:"smooth-scroll",rawName:"v-smooth-scroll",value:({ duration: 3000, offset: _vm.getOffset()-84 }),expression:"{ duration: 3000, offset: getOffset()-84 }"},{name:"lang",rawName:"v-lang.acting",modifiers:{"acting":true}}],staticClass:"nav-link",attrs:{"href":"#people","data-offset":"220","data-toggle":"collapse","data-target":"#navbarSupportedContent-7"}},[_vm._v("Schauspiel")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{directives:[{name:"smooth-scroll",rawName:"v-smooth-scroll",value:({ duration: 3000, offset: _vm.getOffset() }),expression:"{ duration: 3000, offset: getOffset() }"}],staticClass:"nav-link",attrs:{"href":"#news","data-offset":"70","data-toggle":"collapse","data-target":"#navbarSupportedContent-7"}},[_vm._v("News")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{directives:[{name:"smooth-scroll",rawName:"v-smooth-scroll",value:({ duration: 3000, offset: _vm.getOffset() }),expression:"{ duration: 3000, offset: getOffset() }"},{name:"lang",rawName:"v-lang.agentur",modifiers:{"agentur":true}}],staticClass:"nav-link",attrs:{"href":"#agency","data-offset":"70","data-toggle":"collapse","data-target":"#navbarSupportedContent-7"}},[_vm._v("Agentur")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{directives:[{name:"smooth-scroll",rawName:"v-smooth-scroll",value:({ duration: 3000, offset: _vm.getOffset() }),expression:"{ duration: 3000, offset: getOffset() }"},{name:"lang",rawName:"v-lang.kontakt",modifiers:{"kontakt":true}}],staticClass:"nav-link",attrs:{"href":"#contact","data-offset":"70","data-toggle":"collapse","data-target":"#navbarSupportedContent-7"}},[_vm._v("Kontakt")])])]),_vm._v(" "),_vm._m(1)])])])]),_vm._v(" "),_c('main',[_c('section-people'),_vm._v(" "),_c('section-news',{staticStyle:{"margin":"0px","padding":"0px"}}),_vm._v(" "),_c('div',{staticClass:"view intro hm-white-light jarallax parallax-img-2",attrs:{"data-jarallax":"{\"speed\": 0.2}"}},[_c('div',{staticClass:"mask pattern-5 full-bg-img"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"d-flex align-items-center d-flex justify-content-center"},[_c('div',{staticClass:"row mt-5"},[_c('div',{staticClass:"col-md-12 wow fadeIn mt-5 mb-3"},[_c('div',{staticClass:"text-center"},[_c('p',{directives:[{name:"lang",rawName:"v-lang.agentur",modifiers:{"agentur":true}}],staticClass:"display-1 mb-2 wow fadeInDown white-text",staticStyle:{"font-size":"3rem","margin-top":"120px"},attrs:{"data-wow-delay":"0.3s"}},[_vm._v("Agentur")])])])])])])])]),_vm._v(" "),_c('section-agency'),_vm._v(" "),_c('section-contact')],1),_vm._v(" "),_c('section-footer'),_vm._v(" "),_c('modal-imprint'),_vm._v(" "),_c('modal-data-protection')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"navbar-toggler",attrs:{"type":"button","data-toggle":"collapse","data-target":"#navbarSupportedContent-7","aria-controls":"navbarSupportedContent-7","aria-expanded":"false","aria-label":"Toggle navigation"}},[_c('span',{staticClass:"navbar-toggler-icon"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hidden-md-down"},[_c('a',{staticClass:"icons-sm fb-ic",attrs:{"target":"_blank","href":"https://www.facebook.com/pages/Heimanns-Agentur/174592245925723"}},[_c('i',{staticClass:"fa fa-facebook white-text"})]),_vm._v(" "),_c('a',{staticClass:"icons-sm fb-ic",attrs:{"target":"_blank","href":"https://www.instagram.com/heimann.s_agentur/"}},[_c('i',{staticClass:"fa fa-instagram white-text"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 603:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo_white_bg.4b7691b.png";

/***/ }),

/***/ 604:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.fad8c86.png";

/***/ }),

/***/ 650:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 81:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "eventBus", function() { return eventBus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_multilanguage__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_multilanguage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_multilanguage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_lazyload__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_lazyload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_touch__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_touch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_touch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_awesome_swiper__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_swiper_dist_css_swiper_css__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_swiper_dist_css_swiper_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_swiper_dist_css_swiper_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__App__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_smooth_scroll__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_smooth_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_smooth_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_match_media_src__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_resource__ = __webpack_require__(649);
/*require('babel-polyfill');
require('es6-promise/auto');
require('core-js/es6/set');
require('core-js/fn/array/from');
*/


//import 'es6-promise/auto'
//es6Promise.polyfill();

//import 'babel-polyfill'
//import 'core-js/es6/set'
//import 'core-js/fn/array/from'


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuelidate___default.a);


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_multilanguage___default.a, {
  default: 'de',
  de: {
    acting: 'Schauspiel',
    agentur: 'Agentur',
    kontakt: 'Kontakt',
    schauspielerinnen: 'Schauspielerinnen',
    schauspieler: 'Schauspieler',
    vita: 'Vita',
    auszeichnungen: 'Auszeichnungen',
    filmTv: 'Film/TV (Auswahl)',
    theater: 'Theater (Auswahl)',
    sonstiges: 'Sonstiges (Auswahl)',
    geburtsjahr: 'Geburtsjahr',
    nationalitaet: 'Nationalität',
    groesse: 'Größe',
    haarfarbe: 'Haarfarbe',
    augenfarbe: 'Augenfarbe',
    sprachen: 'Sprachen',
    dialekte: 'Dialekte',
    akzent: 'Akzent',
    fuehrerschein: 'Führerschein',
    sport: 'Sport',
    specials: 'Specials',
    musik: 'Musik',
    wohnort: 'Wohnort',
    wohnmoeglichkeit: 'Wohnmöglichkeit',
    website: 'Website',
    ausbildung: 'Ausbildung',
    agenturText1: 'Nach meinem Magister-Studium in Köln (Germanistik, Kunstgeschichte, Geschichte) arbeitete ich sechs Jahre bei einer Kölner Filmproduktion. Danach baute ich 1999-2005 in einer Managementagentur für Moderatoren und Schauspieler den bis dahin noch in den Anfängen steckenden Schauspielbereich auf.',
    agenturText2: 'Im Januar 2006 eröffnete ich Heimann.s Agentur und vertrete dort bis zu 32 Schauspielerinnen und  Schauspieler. Und wie auf den jeweiligen einzelnen Seiten dieser Damen und Herren hier zu sehen ist, ergeben sich seitdem immer wieder sehr schöne Engagements - diesbezüglich herzlichen Dank  für das entgegengebrachte Vertrauen an alle beteiligten Entscheidungsträger!',
    agenturText3: 'Und natürlich bedanke ich mich auch bei all meinen SchauspielerInnen für die Zusammenarbeit - es macht große Freude, mit Euch zu arbeiten!',
    agenturText4: 'Seit 2011 ist Heimann.s Agentur Mitglied der DAFF-Deutsche Akademie für Fernsehen und von 2012-2016 dort im Vorstand tätig. Seit Oktober 2018 ist Heimann.s Agentur Mitglied im Verband der Agenturen.',
    schreibenSieUns: 'Schreiben Sie uns!',
    ihrName: 'Ihr Name',
    ihreEmail: 'Ihre Email',
    betreff: 'Betreff',
    ihreNachricht: 'Ihre Nachricht',
    absenden: 'Absenden',
    nachrichtVersendet: 'Vielen Dank. Ihre Nachricht wurde versendet.',
    fehlerNochmal: 'Ein Fehler ist aufgetreten! Bitte versuchen Sie es später erneut.',
    daff: 'Heimann.s Agentur ist Mitglied',
    drucken: 'Drucken',
    download: 'Herunterladen'
  },
  fr: {
    acting: 'Acteur',
    agentur: 'Agence',
    kontakt: 'Contact',
    schauspielerinnen: 'Actrices (f)',
    schauspieler: 'Actrices (m)',
    vita: 'Vitæ',
    auszeichnungen: 'Prix',
    filmTv: 'Film/TV (sélection)',
    theater: 'Théâtre (sélection)',
    sonstiges: 'D´autres (sélection)',
    geburtsjahr: 'Date de naissance',
    nationalitaet: 'Nationalité',
    groesse: 'Größe',
    haarfarbe: 'Haarfarbe',
    augenfarbe: 'Augenfarbe',
    sprachen: 'Sprachen',
    akzent: 'Akzent',
    fuehrerschein: 'Führerschein',
    sport: 'Sport',
    specials: 'Specials',
    musik: 'Musik',
    wohnort: 'Wohnort',
    wohnmoeglichkeit: 'Wohnmöglichkeit',
    website: 'Website',
    ausbildung: 'Ausbildung',
    agenturText1: 'Nach meinem ...',
    agenturText2: 'Im Januar 2006...',
    agenturText3: 'Und natürlich...',
    agenturText4: 'Seit 2011...',
    schreibenSieUns: 'Ecrivez-nous!',
    ihrName: 'Votre nom',
    ihreEmail: 'Votre émail',
    betreff: 'L´objet',
    ihreNachricht: 'Votre message',
    absenden: 'Envoyer',
    nachrichtVersendet: 'Merci beaucoup. Votre message était envoyé.',
    fehlerNochmal: 'Erreur! Essayez-vous encore une fois plus tard, s´il vous plaît.',
    daff: 'Heimann.s Agentur est membre',
    drucken: 'Imprimer',
    download: 'Download'
  }
});

//import VueRouter from 'vue-router';
//import { routes } from './routes';
//Vue.use(VueRouter);


//const router = new VueRouter({
//    routes
//});



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_lazyload___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_touch___default.a, { name: 'v-touch' });


 // require styles
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_awesome_swiper___default.a /* { default global options } */);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_vue_smooth_scroll___default.a);


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9_vue_match_media_src__["a" /* default */]);


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_10_vue_resource__["a" /* default */]);

var eventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  //router,
  created: function created() {
    /*    (function(d, s, id) {
          var js, fjs = d.getElementsByTagName(s)[0];
          if (d.getElementById(id)) return;
          js = d.createElement(s); js.id = id;
          js.src = 'https://connect.facebook.net/de_DE/sdk.js#xfbml=1&version=v2.11';
          fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'));*/
  },

  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_7__App__["a" /* default */]);
  },
  mq: {
    //phone: '(max-width: 768px)',
    //tablet: '(max-width: 1024px)',
    //desktop: '(min-width: 1024px)', 

    // Exta small devices (portrait Mobile) // max-width 575px
    xs: 'only screen and (max-width: 575px)',
    // Mobile // min-width 576px and max-width 767px
    sm: 'only screen and (min-width: 576px) and (max-width: 767px)',
    //smUp      : 'only screen and (min-width: 576px)',
    //smDown    : 'only screen and (max-width: 767px)',  
    // Tablet // min-width 768px and max-width 991px
    md: 'only screen and (min-width: 768px) and (max-width: 991px)',
    //mdUp      : 'only screen and (min-width: 768px)',
    //mdDown    : 'only screen and (max-width: 991px)',    
    // Desktop // min-width 992px and max-width 1199px
    lg: 'only screen and (min-width: 992px) and (max-width: 1199px)',
    //lgUp      : 'only screen and (min-width: 992px)',
    //lgDown    : 'only screen and (max-width: 1199px)',   
    // Large Desktop // min-width 1200px
    xl: 'only screen and (min-width: 1200px)'
    // detect portrait orientation
    //portrait  : 'only screen and (orientation: portrait)',
    // detect portrait orientation
    //landscape : 'only screen and (orientation: landscape)'
  }
});

/***/ })

},[315]);


// WEBPACK FOOTER //
// static/js/app.31d93d10ea9255a805d6.js